// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options, formDataBodySerializer } from '@hey-api/client-axios'
import type {
  GetPrivateAuthPrivateGetError,
  GetPrivateAuthPrivateGetResponse,
  GetUserPermissionsAuthUserPermissionsGetData,
  GetUserPermissionsAuthUserPermissionsGetError,
  GetUserPermissionsAuthUserPermissionsGetResponse,
  GetRolesAuthRolesGetError,
  GetRolesAuthRolesGetResponse,
  KeycloakWebhookAuthKeycloakWebhookPostError,
  KeycloakWebhookAuthKeycloakWebhookPostResponse,
  SendAccountActionEmailAuthAccountActionsPostData,
  SendAccountActionEmailAuthAccountActionsPostError,
  SendAccountActionEmailAuthAccountActionsPostResponse,
  ToggleUserStatusAuthUserUserIdToggleStatusPostData,
  ToggleUserStatusAuthUserUserIdToggleStatusPostError,
  ToggleUserStatusAuthUserUserIdToggleStatusPostResponse,
  GetCurrentUserInfoAuthProfileGetError,
  GetCurrentUserInfoAuthProfileGetResponse,
  UpdateCurrentUserProfileAuthProfilePatchData,
  UpdateCurrentUserProfileAuthProfilePatchError,
  UpdateCurrentUserProfileAuthProfilePatchResponse,
  ListCompaniesCompaniesGetData,
  ListCompaniesCompaniesGetError,
  ListCompaniesCompaniesGetResponse,
  CreateCompanyCompaniesPostData,
  CreateCompanyCompaniesPostError,
  CreateCompanyCompaniesPostResponse,
  DeleteCompaniesCompaniesDeleteData,
  DeleteCompaniesCompaniesDeleteError,
  DeleteCompaniesCompaniesDeleteResponse,
  GetCompaniesMetadataCompaniesMetadataGetError,
  GetCompaniesMetadataCompaniesMetadataGetResponse,
  ListCompaniesUsersCompaniesUsersGetData,
  ListCompaniesUsersCompaniesUsersGetError,
  ListCompaniesUsersCompaniesUsersGetResponse,
  DeleteCompaniesUsersCompaniesUsersDeleteData,
  DeleteCompaniesUsersCompaniesUsersDeleteError,
  DeleteCompaniesUsersCompaniesUsersDeleteResponse,
  GetCompanyCompaniesCompanyIdGetData,
  GetCompanyCompaniesCompanyIdGetError,
  GetCompanyCompaniesCompanyIdGetResponse,
  UpdateCompanyCompaniesCompanyIdPutData,
  UpdateCompanyCompaniesCompanyIdPutError,
  UpdateCompanyCompaniesCompanyIdPutResponse,
  DeleteCompanyCompaniesCompanyIdDeleteData,
  DeleteCompanyCompaniesCompanyIdDeleteError,
  DeleteCompanyCompaniesCompanyIdDeleteResponse,
  ListCompanyUsersCompaniesCompanyIdUsersGetData,
  ListCompanyUsersCompaniesCompanyIdUsersGetError,
  ListCompanyUsersCompaniesCompanyIdUsersGetResponse,
  AddCompanyUserCompaniesCompanyIdUsersPostData,
  AddCompanyUserCompaniesCompanyIdUsersPostError,
  AddCompanyUserCompaniesCompanyIdUsersPostResponse,
  UpdateCompanyUserCompaniesCompanyIdUsersCompanyUserIdPutData,
  UpdateCompanyUserCompaniesCompanyIdUsersCompanyUserIdPutError,
  UpdateCompanyUserCompaniesCompanyIdUsersCompanyUserIdPutResponse,
  RemoveCompanyUserCompaniesCompanyIdUsersCompanyUserIdDeleteData,
  RemoveCompanyUserCompaniesCompanyIdUsersCompanyUserIdDeleteError,
  RemoveCompanyUserCompaniesCompanyIdUsersCompanyUserIdDeleteResponse,
  GetCompanyUserCompaniesCompanyIdUsersUserIdGetData,
  GetCompanyUserCompaniesCompanyIdUsersUserIdGetError,
  GetCompanyUserCompaniesCompanyIdUsersUserIdGetResponse,
  BulkCreateCompanyUsersCompaniesUsersBulkCreatePostData,
  BulkCreateCompanyUsersCompaniesUsersBulkCreatePostError,
  BulkCreateCompanyUsersCompaniesUsersBulkCreatePostResponse,
  ListFormDefinitionsFormsGetData,
  ListFormDefinitionsFormsGetError,
  ListFormDefinitionsFormsGetResponse,
  CreateFormDefinitionFormsPostData,
  CreateFormDefinitionFormsPostError,
  CreateFormDefinitionFormsPostResponse,
  GetFormMetadataFormsMetadataGetError,
  GetFormMetadataFormsMetadataGetResponse,
  GetFormDefinitionFormsFormDefinitionIdGetData,
  GetFormDefinitionFormsFormDefinitionIdGetError,
  GetFormDefinitionFormsFormDefinitionIdGetResponse,
  UpdateFormDefinitionFormsFormDefinitionIdPutData,
  UpdateFormDefinitionFormsFormDefinitionIdPutError,
  UpdateFormDefinitionFormsFormDefinitionIdPutResponse,
  DeleteFormDefinitionFormsFormDefinitionIdDeleteData,
  DeleteFormDefinitionFormsFormDefinitionIdDeleteError,
  DeleteFormDefinitionFormsFormDefinitionIdDeleteResponse,
  GetQcTasksQcTasksGetData,
  GetQcTasksQcTasksGetError,
  GetQcTasksQcTasksGetResponse,
  QcTasksDicomMetadataQcTasksDicomMetadataGetData,
  QcTasksDicomMetadataQcTasksDicomMetadataGetError,
  QcTasksDicomMetadataQcTasksDicomMetadataGetResponse,
  DownloadDicomQcTasksDownloadDicomGetData,
  DownloadDicomQcTasksDownloadDicomGetError,
  DownloadDicomQcTasksDownloadDicomGetResponse,
  AssignQcTaskQcTasksAssignPatchData,
  AssignQcTaskQcTasksAssignPatchError,
  AssignQcTaskQcTasksAssignPatchResponse,
  UnassignQcTaskQcTasksUnassignPatchData,
  UnassignQcTaskQcTasksUnassignPatchError,
  UnassignQcTaskQcTasksUnassignPatchResponse,
  GetQcUsersQcTasksQcUsersGetData,
  GetQcUsersQcTasksQcUsersGetError,
  GetQcUsersQcTasksQcUsersGetResponse,
  ExcludeQcTasksQcTasksExcludePatchData,
  ExcludeQcTasksQcTasksExcludePatchError,
  ExcludeQcTasksQcTasksExcludePatchResponse,
  ReopenQcTaskQcTasksReopenPatchData,
  ReopenQcTaskQcTasksReopenPatchError,
  ReopenQcTaskQcTasksReopenPatchResponse,
  ResetQcTasksResetPatchData,
  ResetQcTasksResetPatchError,
  ResetQcTasksResetPatchResponse,
  GetQcTaskQcTasksQcTaskIdGetData,
  GetQcTaskQcTasksQcTaskIdGetError,
  GetQcTaskQcTasksQcTaskIdGetResponse,
  CreateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPostData,
  CreateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPostError,
  CreateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPostResponse,
  UpdateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdPutData,
  UpdateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdPutError,
  UpdateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdPutResponse,
  DeleteQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdDeleteData,
  DeleteQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdDeleteError,
  DeleteQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdDeleteResponse,
  QcTaskEsignQcTasksQcTaskIdEsignPostData,
  QcTaskEsignQcTasksQcTaskIdEsignPostError,
  QcTaskEsignQcTasksQcTaskIdEsignPostResponse,
  DeleteExamMetadataQcTasksQcTaskIdExamDeleteData,
  DeleteExamMetadataQcTasksQcTaskIdExamDeleteError,
  DeleteExamMetadataQcTasksQcTaskIdExamDeleteResponse,
  DeleteSeriesMetadataQcTasksSeriesDeleteData,
  DeleteSeriesMetadataQcTasksSeriesDeleteError,
  DeleteSeriesMetadataQcTasksSeriesDeleteResponse,
  UpdateQcTaskFormSubmissionQcTasksQcTaskIdFormSubmissionStudyFormIdPatchData,
  UpdateQcTaskFormSubmissionQcTasksQcTaskIdFormSubmissionStudyFormIdPatchError,
  UpdateQcTaskFormSubmissionQcTasksQcTaskIdFormSubmissionStudyFormIdPatchResponse,
  GetQcTaskMetadataQcTasksQcTaskIdMetadataGetData,
  GetQcTaskMetadataQcTasksQcTaskIdMetadataGetError,
  GetQcTaskMetadataQcTasksQcTaskIdMetadataGetResponse,
  DownloadExamMetadataQcTasksQcTaskIdExamDownloadGetData,
  DownloadExamMetadataQcTasksQcTaskIdExamDownloadGetError,
  DownloadExamMetadataQcTasksQcTaskIdExamDownloadGetResponse,
  UpdateSeriesMetadataDicomTagsQcTasksQcTaskIdExamSeriesSeriesMetadataIdPutData,
  UpdateSeriesMetadataDicomTagsQcTasksQcTaskIdExamSeriesSeriesMetadataIdPutError,
  UpdateSeriesMetadataDicomTagsQcTasksQcTaskIdExamSeriesSeriesMetadataIdPutResponse,
  GetReadTasksReadTasksGetData,
  GetReadTasksReadTasksGetError,
  GetReadTasksReadTasksGetResponse,
  UpdateReadTaskReadTasksPatchData,
  UpdateReadTaskReadTasksPatchError,
  UpdateReadTaskReadTasksPatchResponse,
  AssignReadTasksReadTasksAssignPatchData,
  AssignReadTasksReadTasksAssignPatchError,
  AssignReadTasksReadTasksAssignPatchResponse,
  SkipReadTasksReadTasksSkipPatchData,
  SkipReadTasksReadTasksSkipPatchError,
  SkipReadTasksReadTasksSkipPatchResponse,
  ReadTasksMetadataReadTasksMetadataGetData,
  ReadTasksMetadataReadTasksMetadataGetError,
  ReadTasksMetadataReadTasksMetadataGetResponse,
  ReaderSummaryReadTasksReaderSummaryGetData,
  ReaderSummaryReadTasksReaderSummaryGetError,
  ReaderSummaryReadTasksReaderSummaryGetResponse,
  DownloadDicomReadTasksDownloadDicomGetData,
  DownloadDicomReadTasksDownloadDicomGetError,
  DownloadDicomReadTasksDownloadDicomGetResponse,
  ReopenReadTaskReadTasksReopenPatchData,
  ReopenReadTaskReadTasksReopenPatchError,
  ReopenReadTaskReadTasksReopenPatchResponse,
  ResetReadTasksReadTasksResetPatchData,
  ResetReadTasksReadTasksResetPatchError,
  ResetReadTasksReadTasksResetPatchResponse,
  SaveEcrfSubmissionReadTasksReadTasksPatchData,
  SaveEcrfSubmissionReadTasksReadTasksPatchError,
  SaveEcrfSubmissionReadTasksReadTasksPatchResponse,
  GetPrimaryReadersReadTasksPrimaryReadersGetData,
  GetPrimaryReadersReadTasksPrimaryReadersGetError,
  GetPrimaryReadersReadTasksPrimaryReadersGetResponse,
  UpdateReaderActiveTimeReadTasksUpdateActiveTimePatchData,
  UpdateReaderActiveTimeReadTasksUpdateActiveTimePatchError,
  UpdateReaderActiveTimeReadTasksUpdateActiveTimePatchResponse,
  RespondToReopenRequestReadTasksReopenResponsePostData,
  RespondToReopenRequestReadTasksReopenResponsePostError,
  RespondToReopenRequestReadTasksReopenResponsePostResponse,
  ReadTaskEsignReadTasksEsignPostData,
  ReadTaskEsignReadTasksEsignPostError,
  ReadTaskEsignReadTasksEsignPostResponse,
  GetAdjudicationJustificationsReadTasksAdjudicationJustificationsGetData,
  GetAdjudicationJustificationsReadTasksAdjudicationJustificationsGetError,
  GetAdjudicationJustificationsReadTasksAdjudicationJustificationsGetResponse,
  CopyReadTaskReadTasksCopyPostData,
  CopyReadTaskReadTasksCopyPostError,
  CopyReadTaskReadTasksCopyPostResponse,
  GetStudyAdherenceMetadataStudiesStudyIdAdherenceMetadataGetData,
  GetStudyAdherenceMetadataStudiesStudyIdAdherenceMetadataGetError,
  GetStudyAdherenceMetadataStudiesStudyIdAdherenceMetadataGetResponse,
  ListStudyAdherenceConfigsStudiesStudyIdAdherenceConfigGetData,
  ListStudyAdherenceConfigsStudiesStudyIdAdherenceConfigGetError,
  ListStudyAdherenceConfigsStudiesStudyIdAdherenceConfigGetResponse,
  CreateStudyAdherenceConfigStudiesStudyIdAdherenceConfigPostData,
  CreateStudyAdherenceConfigStudiesStudyIdAdherenceConfigPostError,
  CreateStudyAdherenceConfigStudiesStudyIdAdherenceConfigPostResponse,
  GetStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdGetData,
  GetStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdGetError,
  GetStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdGetResponse,
  UpdateStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdPutData,
  UpdateStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdPutError,
  UpdateStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdPutResponse,
  DeleteStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdDeleteData,
  DeleteStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdDeleteError,
  DeleteStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdDeleteResponse,
  CreateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRulePostData,
  CreateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRulePostError,
  CreateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRulePostResponse,
  UpdateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdPutData,
  UpdateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdPutError,
  UpdateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdPutResponse,
  DeleteStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdDeleteData,
  DeleteStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdDeleteError,
  DeleteStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdDeleteResponse,
  CheckStudyAdherenceStudiesStudyIdAdherenceCheckRuleIdPostData,
  CheckStudyAdherenceStudiesStudyIdAdherenceCheckRuleIdPostError,
  CheckStudyAdherenceStudiesStudyIdAdherenceCheckRuleIdPostResponse,
  StudyFormsStudiesStudyIdFormsGetData,
  StudyFormsStudiesStudyIdFormsGetError,
  StudyFormsStudiesStudyIdFormsGetResponse,
  CreateStudyFormDefinitionStudiesStudyIdFormsPostData,
  CreateStudyFormDefinitionStudiesStudyIdFormsPostError,
  CreateStudyFormDefinitionStudiesStudyIdFormsPostResponse,
  GetStudyFormByIdStudiesStudyIdFormsStudyFormIdGetData,
  GetStudyFormByIdStudiesStudyIdFormsStudyFormIdGetError,
  GetStudyFormByIdStudiesStudyIdFormsStudyFormIdGetResponse,
  UpdateStudyFormDefinitionStudiesStudyIdFormsStudyFormIdPutData,
  UpdateStudyFormDefinitionStudiesStudyIdFormsStudyFormIdPutError,
  UpdateStudyFormDefinitionStudiesStudyIdFormsStudyFormIdPutResponse,
  DeleteStudyFormDefinitionStudiesStudyIdFormsStudyFormIdDeleteData,
  DeleteStudyFormDefinitionStudiesStudyIdFormsStudyFormIdDeleteError,
  DeleteStudyFormDefinitionStudiesStudyIdFormsStudyFormIdDeleteResponse,
  MetadataStudiesMetadataGetError,
  MetadataStudiesMetadataGetResponse,
  GetStudyUsersMetadataStudiesUsersMetadataGetError,
  GetStudyUsersMetadataStudiesUsersMetadataGetResponse,
  GetStudyMetadataStudiesStudyIdMetadataGetData,
  GetStudyMetadataStudiesStudyIdMetadataGetError,
  GetStudyMetadataStudiesStudyIdMetadataGetResponse,
  GetDicomTagsStudiesDicomTagsGetError,
  GetDicomTagsStudiesDicomTagsGetResponse,
  GetPaginatedDicomTagsStudiesDicomTagsGetResponse,
  SeriesLabelsStudiesSeriesLabelsGetError,
  SeriesLabelsStudiesSeriesLabelsGetResponse,
  CreateDraftQcStudiesStudyIdQcDraftPostData,
  CreateDraftQcStudiesStudyIdQcDraftPostError,
  CreateDraftQcStudiesStudyIdQcDraftPostResponse,
  CreateQcStudiesStudyIdQcPostData,
  CreateQcStudiesStudyIdQcPostError,
  CreateQcStudiesStudyIdQcPostResponse,
  GetQcStudiesStudyIdQcGetData,
  GetQcStudiesStudyIdQcGetError,
  GetQcStudiesStudyIdQcGetResponse,
  UpdateDraftQcStudiesStudyIdQcStudyQcRequirementIdDraftPutData,
  UpdateDraftQcStudiesStudyIdQcStudyQcRequirementIdDraftPutError,
  UpdateDraftQcStudiesStudyIdQcStudyQcRequirementIdDraftPutResponse,
  UpdateQcStudiesStudyIdQcStudyQcRequirementIdPutData,
  UpdateQcStudiesStudyIdQcStudyQcRequirementIdPutError,
  UpdateQcStudiesStudyIdQcStudyQcRequirementIdPutResponse,
  CreateDraftReadDesignStudiesStudyIdReadDesignDraftPostData,
  CreateDraftReadDesignStudiesStudyIdReadDesignDraftPostError,
  CreateDraftReadDesignStudiesStudyIdReadDesignDraftPostResponse,
  CreateReadDesignStudiesStudyIdReadDesignPostData,
  CreateReadDesignStudiesStudyIdReadDesignPostError,
  CreateReadDesignStudiesStudyIdReadDesignPostResponse,
  GetStudyReadDesignsStudiesStudyIdReadDesignsGetData,
  GetStudyReadDesignsStudiesStudyIdReadDesignsGetError,
  GetStudyReadDesignsStudiesStudyIdReadDesignsGetResponse,
  GetStudyReadDesignByIdStudiesStudyIdReadDesignReadDesignIdGetData,
  GetStudyReadDesignByIdStudiesStudyIdReadDesignReadDesignIdGetError,
  GetStudyReadDesignByIdStudiesStudyIdReadDesignReadDesignIdGetResponse,
  DeleteReadDesignStudiesStudyIdReadDesignReadDesignIdDeleteData,
  DeleteReadDesignStudiesStudyIdReadDesignReadDesignIdDeleteError,
  DeleteReadDesignStudiesStudyIdReadDesignReadDesignIdDeleteResponse,
  UpdateReadDesignStudiesStudyIdReadDesignReadDesignIdPutData,
  UpdateReadDesignStudiesStudyIdReadDesignReadDesignIdPutError,
  UpdateReadDesignStudiesStudyIdReadDesignReadDesignIdPutResponse,
  UpdateDraftReadDesignStudiesStudyIdReadDesignReadDesignIdDraftPutData,
  UpdateDraftReadDesignStudiesStudyIdReadDesignReadDesignIdDraftPutError,
  UpdateDraftReadDesignStudiesStudyIdReadDesignReadDesignIdDraftPutResponse,
  GetStudyHomepageStudiesHomepageGetData,
  GetStudyHomepageStudiesHomepageGetError,
  GetStudyHomepageStudiesHomepageGetResponse,
  GetStudyByIdStudiesStudyIdGetData,
  GetStudyByIdStudiesStudyIdGetError,
  GetStudyByIdStudiesStudyIdGetResponse,
  UpdateStudyStudiesStudyIdPutData,
  UpdateStudyStudiesStudyIdPutError,
  UpdateStudyStudiesStudyIdPutResponse,
  ParialUpdateStudyStudiesStudyIdPatchData,
  ParialUpdateStudyStudiesStudyIdPatchError,
  ParialUpdateStudyStudiesStudyIdPatchResponse,
  CreateStudyStudiesPostData,
  CreateStudyStudiesPostError,
  CreateStudyStudiesPostResponse,
  CreateDraftStudyStudiesDraftPostData,
  CreateDraftStudyStudiesDraftPostError,
  CreateDraftStudyStudiesDraftPostResponse,
  UpdateDraftStudyStudiesDraftStudyIdPutData,
  UpdateDraftStudyStudiesDraftStudyIdPutError,
  UpdateDraftStudyStudiesDraftStudyIdPutResponse,
  DetailsStudiesStudyIdDetailsGetData,
  DetailsStudiesStudyIdDetailsGetError,
  DetailsStudiesStudyIdDetailsGetResponse,
  PromoteStudyStatusStudiesStudyIdPromotePatchData,
  PromoteStudyStatusStudiesStudyIdPromotePatchError,
  PromoteStudyStatusStudiesStudyIdPromotePatchResponse,
  ExportStudySetupStudiesStudyIdExportStudySetupGetData,
  ExportStudySetupStudiesStudyIdExportStudySetupGetError,
  ExportStudySetupStudiesStudyIdExportStudySetupGetResponse,
  ImportStudySetupStudiesImportStudySetupPostData,
  ImportStudySetupStudiesImportStudySetupPostError,
  ImportStudySetupStudiesImportStudySetupPostResponse,
  StudyTagsStudiesStudyIdTagsDeidGetData,
  StudyTagsStudiesStudyIdTagsDeidGetError,
  StudyTagsStudiesStudyIdTagsDeidGetResponse,
  CreateStudyTagStudiesStudyIdTagsDeidPostData,
  CreateStudyTagStudiesStudyIdTagsDeidPostError,
  CreateStudyTagStudiesStudyIdTagsDeidPostResponse,
  GetStudyTagByIdStudiesStudyIdTagsDeidStudyTagIdGetData,
  GetStudyTagByIdStudiesStudyIdTagsDeidStudyTagIdGetError,
  GetStudyTagByIdStudiesStudyIdTagsDeidStudyTagIdGetResponse,
  UpdateStudyTagStudiesStudyIdTagsDeidStudyTagIdPutData,
  UpdateStudyTagStudiesStudyIdTagsDeidStudyTagIdPutError,
  UpdateStudyTagStudiesStudyIdTagsDeidStudyTagIdPutResponse,
  DeleteStudyTagStudiesStudyIdTagsDeidStudyTagIdDeleteData,
  DeleteStudyTagStudiesStudyIdTagsDeidStudyTagIdDeleteError,
  DeleteStudyTagStudiesStudyIdTagsDeidStudyTagIdDeleteResponse,
  CreateTimepointStudiesStudyIdTimepointPostData,
  CreateTimepointStudiesStudyIdTimepointPostError,
  CreateTimepointStudiesStudyIdTimepointPostResponse,
  UpdateTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdPutData,
  UpdateTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdPutError,
  UpdateTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdPutResponse,
  DeleteTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDeleteData,
  DeleteTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDeleteError,
  DeleteTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDeleteResponse,
  GetStudyTimepointByIdStudiesStudyIdTimepointStudyTimepointRequirementIdGetData,
  GetStudyTimepointByIdStudiesStudyIdTimepointStudyTimepointRequirementIdGetError,
  GetStudyTimepointByIdStudiesStudyIdTimepointStudyTimepointRequirementIdGetResponse,
  CreateDraftTimepointStudiesStudyIdTimepointDraftPostData,
  CreateDraftTimepointStudiesStudyIdTimepointDraftPostError,
  CreateDraftTimepointStudiesStudyIdTimepointDraftPostResponse,
  UpdateDraftTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDraftPutData,
  UpdateDraftTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDraftPutError,
  UpdateDraftTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDraftPutResponse,
  GetStudyTimepointsStudiesStudyIdTimepointsGetData,
  GetStudyTimepointsStudiesStudyIdTimepointsGetError,
  GetStudyTimepointsStudiesStudyIdTimepointsGetResponse,
  GetTimepointContainerUploadTypesStudiesStudyIdTimepointsUploadTypesGetData,
  GetTimepointContainerUploadTypesStudiesStudyIdTimepointsUploadTypesGetError,
  GetTimepointContainerUploadTypesStudiesStudyIdTimepointsUploadTypesGetResponse,
  CreateSubjectStudiesStudyIdSiteSiteIdSubjectsPostData,
  CreateSubjectStudiesStudyIdSiteSiteIdSubjectsPostError,
  CreateSubjectStudiesStudyIdSiteSiteIdSubjectsPostResponse,
  CreateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPostData,
  CreateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPostError,
  CreateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPostResponse,
  GetTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdGetData,
  GetTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdGetError,
  GetTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdGetResponse,
  UpdateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdPatchData,
  UpdateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdPatchError,
  UpdateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdPatchResponse,
  UpdateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatchData,
  UpdateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatchError,
  UpdateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatchResponse,
  GetAllSubjectsTimepointsStudiesStudyIdSubjectsTimepointsGetData,
  GetAllSubjectsTimepointsStudiesStudyIdSubjectsTimepointsGetError,
  GetAllSubjectsTimepointsStudiesStudyIdSubjectsTimepointsGetResponse,
  GetSubjectTimepointsStudiesStudyIdSubjectsSubjectIdTimepointsGetData,
  GetSubjectTimepointsStudiesStudyIdSubjectsSubjectIdTimepointsGetError,
  GetSubjectTimepointsStudiesStudyIdSubjectsSubjectIdTimepointsGetResponse,
  GetTimepointExamReassignmentCheckStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignCheckGetData,
  GetTimepointExamReassignmentCheckStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignCheckGetError,
  GetTimepointExamReassignmentCheckStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignCheckGetResponse,
  GetTimepointExamReassignmentPreviewStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignPreviewGetData,
  GetTimepointExamReassignmentPreviewStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignPreviewGetError,
  GetTimepointExamReassignmentPreviewStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignPreviewGetResponse,
  GetTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPostData,
  GetTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPostError,
  GetTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPostResponse,
  GetSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPostData,
  GetSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPostError,
  GetSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPostResponse,
  DownloadExamStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamDownloadGetData,
  DownloadExamStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamDownloadGetError,
  DownloadExamStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamDownloadGetResponse,
  TimepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPostData,
  TimepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPostError,
  TimepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPostResponse,
  ListStudySubjectConfigurationStudiesStudyIdSubjectConfigurationGetData,
  ListStudySubjectConfigurationStudiesStudyIdSubjectConfigurationGetError,
  ListStudySubjectConfigurationStudiesStudyIdSubjectConfigurationGetResponse,
  CreateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationPostData,
  CreateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationPostError,
  CreateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationPostResponse,
  CreateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationDraftPostData,
  CreateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationDraftPostError,
  CreateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationDraftPostResponse,
  UpdateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationSubjectConfigurationIdPutData,
  UpdateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationSubjectConfigurationIdPutError,
  UpdateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationSubjectConfigurationIdPutResponse,
  UpdateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationSubjectConfigurationIdDraftPutData,
  UpdateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationSubjectConfigurationIdDraftPutError,
  UpdateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationSubjectConfigurationIdDraftPutResponse,
  ListStudyUsersStudiesStudyIdUsersGetData,
  ListStudyUsersStudiesStudyIdUsersGetError,
  ListStudyUsersStudiesStudyIdUsersGetResponse,
  AddStudyUserStudiesStudyIdUsersPostData,
  AddStudyUserStudiesStudyIdUsersPostError,
  AddStudyUserStudiesStudyIdUsersPostResponse,
  AssignUsersToStudyStudiesStudyIdUsersAssignPostData,
  AssignUsersToStudyStudiesStudyIdUsersAssignPostError,
  AssignUsersToStudyStudiesStudyIdUsersAssignPostResponse,
  UnassignUserFromStudyStudiesStudyIdUsersUserIdAssignDeleteData,
  UnassignUserFromStudyStudiesStudyIdUsersUserIdAssignDeleteError,
  UnassignUserFromStudyStudiesStudyIdUsersUserIdAssignDeleteResponse,
  UpdateStudyUserStudiesStudyIdUsersUserIdPutData,
  UpdateStudyUserStudiesStudyIdUsersUserIdPutError,
  UpdateStudyUserStudiesStudyIdUsersUserIdPutResponse,
  ListStudySitesStudiesStudyIdSitesGetData,
  ListStudySitesStudiesStudyIdSitesGetError,
  ListStudySitesStudiesStudyIdSitesGetResponse,
  CreateStudySiteStudiesStudyIdSitesPostData,
  CreateStudySiteStudiesStudyIdSitesPostError,
  CreateStudySiteStudiesStudyIdSitesPostResponse,
  DeleteStudySitesStudiesStudyIdSitesDeleteData,
  DeleteStudySitesStudiesStudyIdSitesDeleteError,
  DeleteStudySitesStudiesStudyIdSitesDeleteResponse,
  GetStudySitesMetadataStudiesStudyIdSitesMetadataGetData,
  GetStudySitesMetadataStudiesStudyIdSitesMetadataGetError,
  GetStudySitesMetadataStudiesStudyIdSitesMetadataGetResponse,
  GetMyStudySiteStudiesStudyIdSitesMySiteGetData,
  GetMyStudySiteStudiesStudyIdSitesMySiteGetError,
  GetMyStudySiteStudiesStudyIdSitesMySiteGetResponse,
  GetStudySiteByIdStudiesStudyIdSitesSiteIdGetData,
  GetStudySiteByIdStudiesStudyIdSitesSiteIdGetError,
  GetStudySiteByIdStudiesStudyIdSitesSiteIdGetResponse,
  UpdateStudySiteStudiesStudyIdSitesSiteIdPutData,
  UpdateStudySiteStudiesStudyIdSitesSiteIdPutError,
  UpdateStudySiteStudiesStudyIdSitesSiteIdPutResponse,
  DeleteStudySiteStudiesStudyIdSitesSiteIdDeleteData,
  DeleteStudySiteStudiesStudyIdSitesSiteIdDeleteError,
  DeleteStudySiteStudiesStudyIdSitesSiteIdDeleteResponse,
  ListSubjectsStudiesStudyIdSubjectsGetData,
  ListSubjectsStudiesStudyIdSubjectsGetError,
  ListSubjectsStudiesStudyIdSubjectsGetResponse,
  CreateSubjectStudiesStudyIdSubjectsPostData,
  CreateSubjectStudiesStudyIdSubjectsPostError,
  CreateSubjectStudiesStudyIdSubjectsPostResponse,
  ListMetadataStudiesStudyIdSubjectsMetadataGetError,
  ListMetadataStudiesStudyIdSubjectsMetadataGetResponse,
  ViewSubjectStudiesStudyIdSubjectsSubjectIdGetData,
  ViewSubjectStudiesStudyIdSubjectsSubjectIdGetError,
  ViewSubjectStudiesStudyIdSubjectsSubjectIdGetResponse,
  UpdateSubjectStudiesStudyIdSubjectsSubjectIdPutData,
  UpdateSubjectStudiesStudyIdSubjectsSubjectIdPutError,
  UpdateSubjectStudiesStudyIdSubjectsSubjectIdPutResponse,
  BulkCreateSubjectsStudiesStudyIdSubjectsBulkCreatePostData,
  BulkCreateSubjectsStudiesStudyIdSubjectsBulkCreatePostError,
  BulkCreateSubjectsStudiesStudyIdSubjectsBulkCreatePostResponse,
  DownloadDicomStudiesSiteDownloadDicomGetData,
  DownloadDicomStudiesSiteDownloadDicomGetError,
  DownloadDicomStudiesSiteDownloadDicomGetResponse,
  NonDicomFileStudiesSiteNonDicomFileGetData,
  NonDicomFileStudiesSiteNonDicomFileGetError,
  NonDicomFileStudiesSiteNonDicomFileGetResponse,
  TimepointSubmissionDicomMetadataStudiesSiteDicomMetadataGetData,
  TimepointSubmissionDicomMetadataStudiesSiteDicomMetadataGetError,
  TimepointSubmissionDicomMetadataStudiesSiteDicomMetadataGetResponse,
  GetReportsStudiesStudyIdReportsReportTypeGetData,
  GetReportsStudiesStudyIdReportsReportTypeGetError,
  GetReportsStudiesStudyIdReportsReportTypeGetResponse,
  DownloadQcReportStudiesStudyIdReportsQcReportTypeDownloadPostData,
  DownloadQcReportStudiesStudyIdReportsQcReportTypeDownloadPostError,
  DownloadQcReportStudiesStudyIdReportsQcReportTypeDownloadPostResponse,
  DownloadTimepointEformReportStudiesStudyIdReportsTimepointEformReportTypeDownloadPostData,
  DownloadTimepointEformReportStudiesStudyIdReportsTimepointEformReportTypeDownloadPostError,
  DownloadTimepointEformReportStudiesStudyIdReportsTimepointEformReportTypeDownloadPostResponse,
  DownloadGeneralReportStudiesStudyIdReportsGeneralReportTypeDownloadPostData,
  DownloadGeneralReportStudiesStudyIdReportsGeneralReportTypeDownloadPostError,
  DownloadGeneralReportStudiesStudyIdReportsGeneralReportTypeDownloadPostResponse,
  DownloadEcrfReportStudiesStudyIdReportsEcrfReportNameDownloadPostData,
  DownloadEcrfReportStudiesStudyIdReportsEcrfReportNameDownloadPostError,
  DownloadEcrfReportStudiesStudyIdReportsEcrfReportNameDownloadPostResponse,
  GenerateEcrfReportStudiesStudyIdSubmissionsSubmissionIdEcrfReportPostData,
  GenerateEcrfReportStudiesStudyIdSubmissionsSubmissionIdEcrfReportPostError,
  GenerateEcrfReportStudiesStudyIdSubmissionsSubmissionIdEcrfReportPostResponse,
  GetPhiRedactionStatusStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionStatusGetData,
  GetPhiRedactionStatusStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionStatusGetError,
  GetPhiRedactionStatusStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionStatusGetResponse,
  ListStudyQueriesStudiesStudyIdQueriesGetData,
  ListStudyQueriesStudiesStudyIdQueriesGetError,
  ListStudyQueriesStudiesStudyIdQueriesGetResponse,
  CreateStudyQueryStudiesStudyIdQueriesPostData,
  CreateStudyQueryStudiesStudyIdQueriesPostError,
  CreateStudyQueryStudiesStudyIdQueriesPostResponse,
  BulkDeleteStudyQueriesStudiesStudyIdQueriesDeleteData,
  BulkDeleteStudyQueriesStudiesStudyIdQueriesDeleteError,
  BulkDeleteStudyQueriesStudiesStudyIdQueriesDeleteResponse,
  GetQueryMetadataStudiesStudyIdQueriesMetadataGetData,
  GetQueryMetadataStudiesStudyIdQueriesMetadataGetError,
  GetQueryMetadataStudiesStudyIdQueriesMetadataGetResponse,
  GetStudyQueryStudiesStudyIdQueriesStudyQueryIdGetData,
  GetStudyQueryStudiesStudyIdQueriesStudyQueryIdGetError,
  GetStudyQueryStudiesStudyIdQueriesStudyQueryIdGetResponse,
  UpdateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatchData,
  UpdateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatchError,
  UpdateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatchResponse,
  DeleteStudyQueryStudiesStudyIdQueriesStudyQueryIdDeleteData,
  DeleteStudyQueryStudiesStudyIdQueriesStudyQueryIdDeleteError,
  DeleteStudyQueryStudiesStudyIdQueriesStudyQueryIdDeleteResponse,
  UpdateStudyQueryStatusStudiesStudyIdQueriesStudyQueryIdUpdateStatusPatchData,
  UpdateStudyQueryStatusStudiesStudyIdQueriesStudyQueryIdUpdateStatusPatchError,
  UpdateStudyQueryStatusStudiesStudyIdQueriesStudyQueryIdUpdateStatusPatchResponse,
  AddQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPostData,
  AddQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPostError,
  AddQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPostResponse,
  LoadFixturesFixturesLoadPostData,
  LoadFixturesFixturesLoadPostError,
  LoadFixturesFixturesLoadPostResponse,
  DeleteFixturesFixturesDeletePostData,
  DeleteFixturesFixturesDeletePostError,
  DeleteFixturesFixturesDeletePostResponse,
  UploadFixturesFixturesUploadPostData,
  UploadFixturesFixturesUploadPostError,
  UploadFixturesFixturesUploadPostResponse,
  ListDicomTagsTagsDeidGetError,
  ListDicomTagsTagsDeidGetResponse,
  CreateDicomTagTagsDeidPostData,
  CreateDicomTagTagsDeidPostError,
  CreateDicomTagTagsDeidPostResponse,
  GetDicomTagTagsDeidDicomTagIdGetData,
  GetDicomTagTagsDeidDicomTagIdGetError,
  GetDicomTagTagsDeidDicomTagIdGetResponse,
  UpdateDicomTagTagsDeidDicomTagIdPutData,
  UpdateDicomTagTagsDeidDicomTagIdPutError,
  UpdateDicomTagTagsDeidDicomTagIdPutResponse,
  DeleteDicomTagTagsDeidDicomTagIdDeleteData,
  DeleteDicomTagTagsDeidDicomTagIdDeleteError,
  DeleteDicomTagTagsDeidDicomTagIdDeleteResponse,
  TemporalHealthWorkflowHealthGetError,
  TemporalHealthWorkflowHealthGetResponse,
  GetWorkflowStatusWorkflowStatusWorkflowIdGetData,
  GetWorkflowStatusWorkflowStatusWorkflowIdGetError,
  GetWorkflowStatusWorkflowStatusWorkflowIdGetResponse,
  StartQcWorkflowWorkflowStudyIdQcStartPostData,
  StartQcWorkflowWorkflowStudyIdQcStartPostError,
  StartQcWorkflowWorkflowStudyIdQcStartPostResponse,
  SignalQcSubmissionWorkflowStudyIdQcWorkflowIdSignalSubmissionPostData,
  SignalQcSubmissionWorkflowStudyIdQcWorkflowIdSignalSubmissionPostError,
  SignalQcSubmissionWorkflowStudyIdQcWorkflowIdSignalSubmissionPostResponse,
  StudyTimepointOptionsTusFilesTimepointFilesOptionsError,
  StudyTimepointOptionsTusFilesTimepointFilesOptionsResponse,
  StudyTimepointCreateTusUploadTimepointFilesPostData,
  StudyTimepointCreateTusUploadTimepointFilesPostError,
  StudyTimepointCreateTusUploadTimepointFilesPostResponse,
  StudyTimepointUploadTusChunkTimepointFilesUploadIdPatchData,
  StudyTimepointUploadTusChunkTimepointFilesUploadIdPatchError,
  StudyTimepointUploadTusChunkTimepointFilesUploadIdPatchResponse,
  StudyTimepointStatusTusUploadTimepointFilesUploadIdHeadData,
  StudyTimepointStatusTusUploadTimepointFilesUploadIdHeadError,
  StudyTimepointStatusTusUploadTimepointFilesUploadIdHeadResponse,
  StudyTimepointDeleteTusUploadTimepointFilesUploadIdDeleteData,
  StudyTimepointDeleteTusUploadTimepointFilesUploadIdDeleteError,
  StudyTimepointDeleteTusUploadTimepointFilesUploadIdDeleteResponse,
  ListSeriesLabelsSeriesLabelsGetData,
  ListSeriesLabelsSeriesLabelsGetError,
  ListSeriesLabelsSeriesLabelsGetResponse,
  CreateSeriesLabelSeriesLabelsPostData,
  CreateSeriesLabelSeriesLabelsPostError,
  CreateSeriesLabelSeriesLabelsPostResponse,
  GetSeriesLabelMetadataSeriesLabelsMetadataGetError,
  GetSeriesLabelMetadataSeriesLabelsMetadataGetResponse,
  GetSeriesLabelSeriesLabelsSeriesLabelIdGetData,
  GetSeriesLabelSeriesLabelsSeriesLabelIdGetError,
  GetSeriesLabelSeriesLabelsSeriesLabelIdGetResponse,
  UpdateSeriesLabelSeriesLabelsSeriesLabelIdPutData,
  UpdateSeriesLabelSeriesLabelsSeriesLabelIdPutError,
  UpdateSeriesLabelSeriesLabelsSeriesLabelIdPutResponse,
  DeleteSeriesLabelSeriesLabelsSeriesLabelIdDeleteData,
  DeleteSeriesLabelSeriesLabelsSeriesLabelIdDeleteError,
  DeleteSeriesLabelSeriesLabelsSeriesLabelIdDeleteResponse,
  BatchDeleteSeriesLabelsSeriesLabelsBatchDeletePostData,
  BatchDeleteSeriesLabelsSeriesLabelsBatchDeletePostError,
  BatchDeleteSeriesLabelsSeriesLabelsBatchDeletePostResponse,
  ListUsersUsersGetData,
  ListUsersUsersGetError,
  ListUsersUsersGetResponse,
  AddUserUsersPostData,
  AddUserUsersPostError,
  AddUserUsersPostResponse,
  GetUserUsersUserIdGetData,
  GetUserUsersUserIdGetError,
  GetUserUsersUserIdGetResponse,
  UpdateUserUsersUserIdPutData,
  UpdateUserUsersUserIdPutError,
  UpdateUserUsersUserIdPutResponse,
  RemoveUserUsersUserIdDeleteData,
  RemoveUserUsersUserIdDeleteError,
  RemoveUserUsersUserIdDeleteResponse,
  ListUserStudyAssignmentsUsersUserIdStudyAssignmentsGetData,
  ListUserStudyAssignmentsUsersUserIdStudyAssignmentsGetError,
  ListUserStudyAssignmentsUsersUserIdStudyAssignmentsGetResponse,
  DeleteUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdDeleteData,
  DeleteUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdDeleteError,
  DeleteUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdDeleteResponse,
  UpdateUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdPatchData,
  UpdateUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdPatchError,
  UpdateUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdPatchResponse,
  GetStudyAssignmentsMetadataUsersStudyAssignmentsMetadataGetError,
  GetStudyAssignmentsMetadataUsersStudyAssignmentsMetadataGetResponse,
  CreateUserStudyAssignmentsUsersUserIdStudyAssignmentsPostData,
  CreateUserStudyAssignmentsUsersUserIdStudyAssignmentsPostError,
  CreateUserStudyAssignmentsUsersUserIdStudyAssignmentsPostResponse,
  HealthCheckHealthGetError,
  HealthCheckHealthGetResponse,
  TriggerErrorSentryDebugGetError,
  TriggerErrorSentryDebugGetResponse,
  PingDbPingDbGetError,
  PingDbPingDbGetResponse,
  CreateBulkCompanyCompaniesPostData,
  UpdatePhiRedactionBoundingBoxesStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionBoundingBoxesPutData,
  UpdatePhiRedactionBoundingBoxesStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionBoundingBoxesPutError,
  UpdatePhiRedactionBoundingBoxesStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionBoundingBoxesPutResponse,
  DownloadUserAuditReportUsersAuditReportDownloadPostResponse,
  DownloadUserAuditReportUsersAuditReportDownloadPostError,
  UpdateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatchData,
  UpdateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatchError,
  UpdateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatchResponse,
  StudyReadDesignDetailsStudiesStudyIdStudyReadDesignDetailsGetData,
  StudyReadDesignDetailsStudiesStudyIdStudyReadDesignDetailsGetError,
  StudyReadDesignDetailsStudiesStudyIdStudyReadDesignDetailsGetResponse,
} from './types.gen'

export const client = createClient(createConfig())

/**
 * Get Private
 */
export const getPrivateAuthPrivateGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetPrivateAuthPrivateGetResponse, GetPrivateAuthPrivateGetError, ThrowOnError>(
    {
      ...options,
      url: '/auth/private',
    },
  )
}

/**
 * Get User Permissions
 */
export const getUserPermissionsAuthUserPermissionsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserPermissionsAuthUserPermissionsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetUserPermissionsAuthUserPermissionsGetResponse,
    GetUserPermissionsAuthUserPermissionsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/user/permissions',
  })
}

/**
 * Get Roles
 */
export const getRolesAuthRolesGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetRolesAuthRolesGetResponse, GetRolesAuthRolesGetError, ThrowOnError>({
    ...options,
    url: '/auth/roles',
  })
}

/**
 * Keycloak Webhook
 */
export const keycloakWebhookAuthKeycloakWebhookPost = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    KeycloakWebhookAuthKeycloakWebhookPostResponse,
    KeycloakWebhookAuthKeycloakWebhookPostError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/keycloak/webhook',
  })
}

/**
 * Send Account Action Email
 * Send an email to a user with account action links.
 */
export const sendAccountActionEmailAuthAccountActionsPost = <ThrowOnError extends boolean = false>(
  options: Options<SendAccountActionEmailAuthAccountActionsPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SendAccountActionEmailAuthAccountActionsPostResponse,
    SendAccountActionEmailAuthAccountActionsPostError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/account/actions',
  })
}

/**
 * Toggle User Status
 * Toggle a user's status between VERIFIED and DEACTIVATED.
 */
export const toggleUserStatusAuthUserUserIdToggleStatusPost = <ThrowOnError extends boolean = false>(
  options: Options<ToggleUserStatusAuthUserUserIdToggleStatusPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ToggleUserStatusAuthUserUserIdToggleStatusPostResponse,
    ToggleUserStatusAuthUserUserIdToggleStatusPostError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/user/{user_id}/toggle-status',
  })
}

/**
 * Get Current User Info
 * Retrieve comprehensive information about the authenticated user.
 */
export const getCurrentUserInfoAuthProfileGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCurrentUserInfoAuthProfileGetResponse,
    GetCurrentUserInfoAuthProfileGetError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/profile',
  })
}

/**
 * Update Current User Profile
 * Update the authenticated user's profile information.
 */
export const updateCurrentUserProfileAuthProfilePatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCurrentUserProfileAuthProfilePatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateCurrentUserProfileAuthProfilePatchResponse,
    UpdateCurrentUserProfileAuthProfilePatchError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/profile',
  })
}

/**
 * List Companies
 */
export const listCompaniesCompaniesGet = <ThrowOnError extends boolean = false>(
  options: Options<ListCompaniesCompaniesGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCompaniesCompaniesGetResponse,
    ListCompaniesCompaniesGetError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/',
  })
}

/**
 * Bulk Create Company
 */
export const createBulkCompanyCompaniesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateBulkCompanyCompaniesPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCompanyCompaniesPostResponse,
    CreateCompanyCompaniesPostError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/bulk_create',
  })
}

/**
 * Create Company
 */
export const createCompanyCompaniesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateCompanyCompaniesPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCompanyCompaniesPostResponse,
    CreateCompanyCompaniesPostError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/',
  })
}

/**
 * Delete Companies
 */
export const deleteCompaniesCompaniesDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCompaniesCompaniesDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteCompaniesCompaniesDeleteResponse,
    DeleteCompaniesCompaniesDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/',
  })
}

/**
 * Get Companies Metadata
 */
export const getCompaniesMetadataCompaniesMetadataGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCompaniesMetadataCompaniesMetadataGetResponse,
    GetCompaniesMetadataCompaniesMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/metadata',
  })
}

/**
 * List Companies Users
 */
export const listCompaniesUsersCompaniesUsersGet = <ThrowOnError extends boolean = false>(
  options: Options<ListCompaniesUsersCompaniesUsersGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCompaniesUsersCompaniesUsersGetResponse,
    ListCompaniesUsersCompaniesUsersGetError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/users',
  })
}

/**
 * Delete Companies Users
 */
export const deleteCompaniesUsersCompaniesUsersDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCompaniesUsersCompaniesUsersDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteCompaniesUsersCompaniesUsersDeleteResponse,
    DeleteCompaniesUsersCompaniesUsersDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/users',
  })
}

/**
 * Get Company
 */
export const getCompanyCompaniesCompanyIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetCompanyCompaniesCompanyIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCompanyCompaniesCompanyIdGetResponse,
    GetCompanyCompaniesCompanyIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/{company_id}',
  })
}

/**
 * Update Company
 */
export const updateCompanyCompaniesCompanyIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCompanyCompaniesCompanyIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateCompanyCompaniesCompanyIdPutResponse,
    UpdateCompanyCompaniesCompanyIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/{company_id}',
  })
}

/**
 * Delete Company
 */
export const deleteCompanyCompaniesCompanyIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCompanyCompaniesCompanyIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteCompanyCompaniesCompanyIdDeleteResponse,
    DeleteCompanyCompaniesCompanyIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/{company_id}',
  })
}

/**
 * List Company Users
 */
export const listCompanyUsersCompaniesCompanyIdUsersGet = <ThrowOnError extends boolean = false>(
  options: Options<ListCompanyUsersCompaniesCompanyIdUsersGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCompanyUsersCompaniesCompanyIdUsersGetResponse,
    ListCompanyUsersCompaniesCompanyIdUsersGetError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/{company_id}/users',
  })
}

/**
 * Add Company User
 */
export const addCompanyUserCompaniesCompanyIdUsersPost = <ThrowOnError extends boolean = false>(
  options: Options<AddCompanyUserCompaniesCompanyIdUsersPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AddCompanyUserCompaniesCompanyIdUsersPostResponse,
    AddCompanyUserCompaniesCompanyIdUsersPostError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/{company_id}/users',
  })
}

/**
 * Update Company User
 */
export const updateCompanyUserCompaniesCompanyIdUsersCompanyUserIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCompanyUserCompaniesCompanyIdUsersCompanyUserIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateCompanyUserCompaniesCompanyIdUsersCompanyUserIdPutResponse,
    UpdateCompanyUserCompaniesCompanyIdUsersCompanyUserIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/{company_id}/users/{company_user_id}',
  })
}

/**
 * Remove Company User
 */
export const removeCompanyUserCompaniesCompanyIdUsersCompanyUserIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<RemoveCompanyUserCompaniesCompanyIdUsersCompanyUserIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    RemoveCompanyUserCompaniesCompanyIdUsersCompanyUserIdDeleteResponse,
    RemoveCompanyUserCompaniesCompanyIdUsersCompanyUserIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/{company_id}/users/{company_user_id}',
  })
}

/**
 * Get Company User
 */
export const getCompanyUserCompaniesCompanyIdUsersUserIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetCompanyUserCompaniesCompanyIdUsersUserIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCompanyUserCompaniesCompanyIdUsersUserIdGetResponse,
    GetCompanyUserCompaniesCompanyIdUsersUserIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/{company_id}/users/{user_id}',
  })
}

/**
 * Bulk Create Company Users
 */
export const bulkCreateCompanyUsersCompaniesUsersBulkCreatePost = <ThrowOnError extends boolean = false>(
  options: Options<BulkCreateCompanyUsersCompaniesUsersBulkCreatePostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BulkCreateCompanyUsersCompaniesUsersBulkCreatePostResponse,
    BulkCreateCompanyUsersCompaniesUsersBulkCreatePostError,
    ThrowOnError
  >({
    ...options,
    url: '/companies/users/bulk_create',
  })
}

/**
 * List Form Definitions
 */
export const listFormDefinitionsFormsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListFormDefinitionsFormsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListFormDefinitionsFormsGetResponse,
    ListFormDefinitionsFormsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/forms/',
  })
}

/**
 * Create Form Definition
 */
export const createFormDefinitionFormsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateFormDefinitionFormsPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateFormDefinitionFormsPostResponse,
    CreateFormDefinitionFormsPostError,
    ThrowOnError
  >({
    ...options,
    url: '/forms/',
  })
}

/**
 * Get Form Metadata
 */
export const getFormMetadataFormsMetadataGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetFormMetadataFormsMetadataGetResponse,
    GetFormMetadataFormsMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/forms/metadata',
  })
}

/**
 * Get Form Definition
 */
export const getFormDefinitionFormsFormDefinitionIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetFormDefinitionFormsFormDefinitionIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetFormDefinitionFormsFormDefinitionIdGetResponse,
    GetFormDefinitionFormsFormDefinitionIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/forms/{form_definition_id}',
  })
}

/**
 * Update Form Definition
 */
export const updateFormDefinitionFormsFormDefinitionIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFormDefinitionFormsFormDefinitionIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateFormDefinitionFormsFormDefinitionIdPutResponse,
    UpdateFormDefinitionFormsFormDefinitionIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/forms/{form_definition_id}',
  })
}

/**
 * Delete Form Definition
 */
export const deleteFormDefinitionFormsFormDefinitionIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFormDefinitionFormsFormDefinitionIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteFormDefinitionFormsFormDefinitionIdDeleteResponse,
    DeleteFormDefinitionFormsFormDefinitionIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/forms/{form_definition_id}',
  })
}

/**
 * Get Qc Tasks
 * Retrieve a list of QC tasks based on the study id and selected category.
 */
export const getQcTasksQcTasksGet = <ThrowOnError extends boolean = false>(
  options: Options<GetQcTasksQcTasksGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetQcTasksQcTasksGetResponse, GetQcTasksQcTasksGetError, ThrowOnError>({
    ...options,
    url: '/qc_tasks/',
  })
}

/**
 * Qc Tasks:Dicom Metadata
 * Retrieves the metadata qc task based on the read qc id and study id.
 */
export const qcTasksDicomMetadataQcTasksDicomMetadataGet = <ThrowOnError extends boolean = false>(
  options: Options<QcTasksDicomMetadataQcTasksDicomMetadataGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    QcTasksDicomMetadataQcTasksDicomMetadataGetResponse,
    QcTasksDicomMetadataQcTasksDicomMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/dicom_metadata',
  })
}

/**
 * Download Dicom
 * Returns DICOM file as url
 */
export const downloadDicomQcTasksDownloadDicomGet = <ThrowOnError extends boolean = false>(
  options: Options<DownloadDicomQcTasksDownloadDicomGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    DownloadDicomQcTasksDownloadDicomGetResponse,
    DownloadDicomQcTasksDownloadDicomGetError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/download-dicom',
  })
}

/**
 * Assign Qc Task
 * Assign a list of QC tasks to a user.
 */
export const assignQcTaskQcTasksAssignPatch = <ThrowOnError extends boolean = false>(
  options: Options<AssignQcTaskQcTasksAssignPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    AssignQcTaskQcTasksAssignPatchResponse,
    AssignQcTaskQcTasksAssignPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/assign',
  })
}

/**
 * Unassign Qc Task
 * Unassign a list of QC tasks to a user.
 */
export const unassignQcTaskQcTasksUnassignPatch = <ThrowOnError extends boolean = false>(
  options: Options<UnassignQcTaskQcTasksUnassignPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UnassignQcTaskQcTasksUnassignPatchResponse,
    UnassignQcTaskQcTasksUnassignPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/unassign',
  })
}

/**
 * Get Qc Users
 * Retrieve a list of QC user based on the study id.
 */
export const getQcUsersQcTasksQcUsersGet = <ThrowOnError extends boolean = false>(
  options: Options<GetQcUsersQcTasksQcUsersGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetQcUsersQcTasksQcUsersGetResponse,
    GetQcUsersQcTasksQcUsersGetError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/qc_users',
  })
}

/**
 * Exclude Qc Tasks
 * Exclude a list of QC tasks.
 */
export const excludeQcTasksQcTasksExcludePatch = <ThrowOnError extends boolean = false>(
  options: Options<ExcludeQcTasksQcTasksExcludePatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    ExcludeQcTasksQcTasksExcludePatchResponse,
    ExcludeQcTasksQcTasksExcludePatchError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/exclude',
  })
}

/**
 * Reopen Qc Task
 * Reopen request for a QC task.
 */
export const reopenQcTaskQcTasksReopenPatch = <ThrowOnError extends boolean = false>(
  options: Options<ReopenQcTaskQcTasksReopenPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    ReopenQcTaskQcTasksReopenPatchResponse,
    ReopenQcTaskQcTasksReopenPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/reopen',
  })
}

/**
 * Reset
 * Reset a list of QC tasks.
 */
export const resetQcTasksResetPatch = <ThrowOnError extends boolean = false>(
  options: Options<ResetQcTasksResetPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<ResetQcTasksResetPatchResponse, ResetQcTasksResetPatchError, ThrowOnError>({
    ...options,
    url: '/qc_tasks/reset',
  })
}

/**
 * Get Qc Task
 * Retrieve the details (including timepoint and container details) of a QC task based on the study id.
 */
export const getQcTaskQcTasksQcTaskIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetQcTaskQcTasksQcTaskIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetQcTaskQcTasksQcTaskIdGetResponse,
    GetQcTaskQcTasksQcTaskIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/{qc_task_id}',
  })
}

/**
 * Create Qc Study Definition
 * Create a new Study definition for a Qc task submission
 */
export const createQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPostData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).post<
    CreateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPostResponse,
    CreateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPostError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/{qc_task_id}/submissions/{qc_task_submission_id}/study_definitions',
  })
}

/**
 * Update Qc Study Definition
 * Update a new Study definition for a Qc task submission.
 * Study series that are not present in the study definition schema are deleted.
 */
export const updateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdPutData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).put<
    UpdateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdPutResponse,
    UpdateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/{qc_task_id}/submissions/{qc_task_submission_id}/study_definitions/{study_definition_id}',
  })
}

/**
 * Delete Qc Study Definition
 * Delete a new Study definition for a Qc task submission.
 */
export const deleteQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdDeleteData,
      ThrowOnError
    >,
  ) => {
    return (options?.client ?? client).delete<
      DeleteQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdDeleteResponse,
      DeleteQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsStudyDefinitionIdDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/qc_tasks/{qc_task_id}/submissions/{qc_task_submission_id}/study_definitions/{study_definition_id}',
    })
  }

/**
 * Capture eSign details for a QC Task submission
 */
export const qcTaskEsignQcTasksQcTaskIdEsignPost = <ThrowOnError extends boolean = false>(
  options: Options<QcTaskEsignQcTasksQcTaskIdEsignPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    QcTaskEsignQcTasksQcTaskIdEsignPostResponse,
    QcTaskEsignQcTasksQcTaskIdEsignPostError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/{qc_task_id}/esign',
  })
}

/**
 * Delete Exam Metadata
 * Delete exam metadata for a QC task submission.
 */
export const deleteExamMetadataQcTasksQcTaskIdExamDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteExamMetadataQcTasksQcTaskIdExamDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteExamMetadataQcTasksQcTaskIdExamDeleteResponse,
    DeleteExamMetadataQcTasksQcTaskIdExamDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/{qc_task_id}/exam',
  })
}

/**
 * Delete Series Metadata
 * Delete series metadata for a study timepoint container submission.
 */
export const deleteSeriesMetadataQcTasksSeriesDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSeriesMetadataQcTasksSeriesDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteSeriesMetadataQcTasksSeriesDeleteResponse,
    DeleteSeriesMetadataQcTasksSeriesDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/series',
  })
}

/**
 * Update Qc Task Form Submission
 * Update an existing QC task submission's form definition ID and submitted form data.
 */
export const updateQcTaskFormSubmissionQcTasksQcTaskIdFormSubmissionStudyFormIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateQcTaskFormSubmissionQcTasksQcTaskIdFormSubmissionStudyFormIdPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateQcTaskFormSubmissionQcTasksQcTaskIdFormSubmissionStudyFormIdPatchResponse,
    UpdateQcTaskFormSubmissionQcTasksQcTaskIdFormSubmissionStudyFormIdPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/{qc_task_id}/form-submission/{study_form_id}',
  })
}

/**
 * Get Qc Task Metadata
 * Retrieve metadata for a QC task, including form definition.
 */
export const getQcTaskMetadataQcTasksQcTaskIdMetadataGet = <ThrowOnError extends boolean = false>(
  options: Options<GetQcTaskMetadataQcTasksQcTaskIdMetadataGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetQcTaskMetadataQcTasksQcTaskIdMetadataGetResponse,
    GetQcTaskMetadataQcTasksQcTaskIdMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/{qc_task_id}/metadata',
  })
}

/**
 * Download Exam Metadata
 * Download exam metadata for a QC task submission.
 */
export const downloadExamMetadataQcTasksQcTaskIdExamDownloadGet = <ThrowOnError extends boolean = false>(
  options: Options<DownloadExamMetadataQcTasksQcTaskIdExamDownloadGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    DownloadExamMetadataQcTasksQcTaskIdExamDownloadGetResponse,
    DownloadExamMetadataQcTasksQcTaskIdExamDownloadGetError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/{qc_task_id}/exam_download',
  })
}

/**
 * Update Series Metadata Dicom Tags
 * Create or update dicom tags for a series metadata.
 */
export const updateSeriesMetadataDicomTagsQcTasksQcTaskIdExamSeriesSeriesMetadataIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateSeriesMetadataDicomTagsQcTasksQcTaskIdExamSeriesSeriesMetadataIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateSeriesMetadataDicomTagsQcTasksQcTaskIdExamSeriesSeriesMetadataIdPutResponse,
    UpdateSeriesMetadataDicomTagsQcTasksQcTaskIdExamSeriesSeriesMetadataIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/qc_tasks/{qc_task_id}/exam_series/{series_metadata_id}',
  })
}

/**
 * Get Read Tasks
 * Retrieve a list of read tasks based on the study id and selected category.
 */
export const getReadTasksReadTasksGet = <ThrowOnError extends boolean = false>(
  options: Options<GetReadTasksReadTasksGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetReadTasksReadTasksGetResponse, GetReadTasksReadTasksGetError, ThrowOnError>(
    {
      ...options,
      url: '/read_tasks/',
    },
  )
}

/**
 * Study Read Design Details
 */
export const studyReadDesignDetailsStudiesStudyIdStudyReadDesignDetailsGet = <ThrowOnError extends boolean = false>(
  options: Options<StudyReadDesignDetailsStudiesStudyIdStudyReadDesignDetailsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    StudyReadDesignDetailsStudiesStudyIdStudyReadDesignDetailsGetResponse,
    StudyReadDesignDetailsStudiesStudyIdStudyReadDesignDetailsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/study-read-design-details',
  })
}

/**
 * Update Read Task
 * Update read tasks. Supports both single and bulk operations:
 * - Assigning tasks to a reader
 * - Setting tasks status to ON_HOLD
 * - Soft deleting tasks
 */
export const updateReadTaskReadTasksPatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReadTaskReadTasksPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateReadTaskReadTasksPatchResponse,
    UpdateReadTaskReadTasksPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/',
  })
}

/**
 * Assign Read Tasks
 * Assign tasks to the logged-in user and return the processed and unprocessed task IDs.
 */
export const assignReadTasksReadTasksAssignPatch = <ThrowOnError extends boolean = false>(
  options: Options<AssignReadTasksReadTasksAssignPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    AssignReadTasksReadTasksAssignPatchResponse,
    AssignReadTasksReadTasksAssignPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/assign',
  })
}

/**
 * Skip Read Tasks
 * Skip tasks in progress assigned to the logged-in user and return the processed and unprocessed task IDs.
 * Tasks will be marked as 'Skipped' immediately without requiring IAM approval.
 */
export const skipReadTasksReadTasksSkipPatch = <ThrowOnError extends boolean = false>(
  options: Options<SkipReadTasksReadTasksSkipPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    SkipReadTasksReadTasksSkipPatchResponse,
    SkipReadTasksReadTasksSkipPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/skip',
  })
}

/**
 * Read Tasks:Metadata
 * Retrieves the metadata read task based on the read task id and study id.
 */
export const readTasksMetadataReadTasksMetadataGet = <ThrowOnError extends boolean = false>(
  options: Options<ReadTasksMetadataReadTasksMetadataGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ReadTasksMetadataReadTasksMetadataGetResponse,
    ReadTasksMetadataReadTasksMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/metadata',
  })
}

/**
 * Reader Summary
 * Retrieves the read task summary data. Handles both regular and adjudication tasks:
 * - For regular tasks: returns single reader's data
 * - For adjudication tasks: returns all readers' data
 */
export const readerSummaryReadTasksReaderSummaryGet = <ThrowOnError extends boolean = false>(
  options: Options<ReaderSummaryReadTasksReaderSummaryGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ReaderSummaryReadTasksReaderSummaryGetResponse,
    ReaderSummaryReadTasksReaderSummaryGetError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/reader-summary',
  })
}

/**
 * Download Dicom
 * Returns DICOM file as url
 */
export const downloadDicomReadTasksDownloadDicomGet = <ThrowOnError extends boolean = false>(
  options: Options<DownloadDicomReadTasksDownloadDicomGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    DownloadDicomReadTasksDownloadDicomGetResponse,
    DownloadDicomReadTasksDownloadDicomGetError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/download-dicom',
  })
}

/**
 * Reopen Read Task
 * Reopen request for read tasks.
 */
export const reopenReadTaskReadTasksReopenPatch = <ThrowOnError extends boolean = false>(
  options: Options<ReopenReadTaskReadTasksReopenPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    ReopenReadTaskReadTasksReopenPatchResponse,
    ReopenReadTaskReadTasksReopenPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/reopen',
  })
}

/**
 * Reset Read Tasks
 * Reset tasks and return the processed and unprocessed task IDs.
 */
export const resetReadTasksReadTasksResetPatch = <ThrowOnError extends boolean = false>(
  options: Options<ResetReadTasksReadTasksResetPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    ResetReadTasksReadTasksResetPatchResponse,
    ResetReadTasksReadTasksResetPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/reset',
  })
}

/**
 * Save Ecrf Submission
 * Save an eCRF submission.
 */
export const saveEcrfSubmissionReadTasksReadTasksPatch = <ThrowOnError extends boolean = false>(
  options: Options<SaveEcrfSubmissionReadTasksReadTasksPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    SaveEcrfSubmissionReadTasksReadTasksPatchResponse,
    SaveEcrfSubmissionReadTasksReadTasksPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/read_tasks',
  })
}

/**
 * Get Primary Readers
 * Retrieve a list of primary readers based on the study id.
 */
export const getPrimaryReadersReadTasksPrimaryReadersGet = <ThrowOnError extends boolean = false>(
  options: Options<GetPrimaryReadersReadTasksPrimaryReadersGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPrimaryReadersReadTasksPrimaryReadersGetResponse,
    GetPrimaryReadersReadTasksPrimaryReadersGetError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/primary_readers',
  })
}

/**
 * Update Reader Active Time
 * Update the active time for the assigned reader for specific task:
 */
export const updateReaderActiveTimeReadTasksUpdateActiveTimePatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReaderActiveTimeReadTasksUpdateActiveTimePatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateReaderActiveTimeReadTasksUpdateActiveTimePatchResponse,
    UpdateReaderActiveTimeReadTasksUpdateActiveTimePatchError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/update-active-time',
  })
}

/**
 * Respond To Reopen Request
 * Respond to reopen requests for tasks.
 * Approve: Moves task to IN_PROGRESS
 * Decline: Moves task back to COMPLETE with provided reason
 */
export const respondToReopenRequestReadTasksReopenResponsePost = <ThrowOnError extends boolean = false>(
  options: Options<RespondToReopenRequestReadTasksReopenResponsePostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RespondToReopenRequestReadTasksReopenResponsePostResponse,
    RespondToReopenRequestReadTasksReopenResponsePostError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/reopen-response',
  })
}

/**
 * Capture adjudication decision with eSign details for a read task
 * Endpoint to capture e-signature for a read task (regular flow or adjudication flow).
 *
 * For regular flow:
 * - Updates read task status to COMPLETE
 * - Updates read task submission status to COMPLETE
 *
 * For adjudication flow:
 * - Processes adjudication decision data
 * - Updates read task status to COMPLETE
 * - Updates read task submission status to COMPLETE
 *
 * Authentication is required with appropriate SAVE_ECRF permission.
 */
export const readTaskEsignReadTasksEsignPost = <ThrowOnError extends boolean = false>(
  options: Options<ReadTaskEsignReadTasksEsignPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ReadTaskEsignReadTasksEsignPostResponse,
    ReadTaskEsignReadTasksEsignPostError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/esign',
  })
}

/**
 * Get list of adjudication justifications
 * Endpoint to retrieve all available adjudication justifications.
 *
 * This list is used to populate dropdown menus or selection lists for adjudication decisions.
 * Authentication is required with appropriate READ_TASK_VIEW permission.
 */
export const getAdjudicationJustificationsReadTasksAdjudicationJustificationsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdjudicationJustificationsReadTasksAdjudicationJustificationsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAdjudicationJustificationsReadTasksAdjudicationJustificationsGetResponse,
    GetAdjudicationJustificationsReadTasksAdjudicationJustificationsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/adjudication_justifications',
  })
}

/**
 * Copy Read Task
 * Copy a read task with the specified copy mode.
 * Returns the workflow ID of the started workflow.
 */
export const copyReadTaskReadTasksCopyPost = <ThrowOnError extends boolean = false>(
  options: Options<CopyReadTaskReadTasksCopyPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CopyReadTaskReadTasksCopyPostResponse,
    CopyReadTaskReadTasksCopyPostError,
    ThrowOnError
  >({
    ...options,
    url: '/read_tasks/copy',
  })
}

/**
 * Get Study Adherence Metadata
 * Retrieve metadata for study adherence.
 */
export const getStudyAdherenceMetadataStudiesStudyIdAdherenceMetadataGet = <ThrowOnError extends boolean = false>(
  options: Options<GetStudyAdherenceMetadataStudiesStudyIdAdherenceMetadataGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyAdherenceMetadataStudiesStudyIdAdherenceMetadataGetResponse,
    GetStudyAdherenceMetadataStudiesStudyIdAdherenceMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/adherence/metadata',
  })
}

/**
 * List Study Adherence Configs
 * List adherence configs for a study.
 */
export const listStudyAdherenceConfigsStudiesStudyIdAdherenceConfigGet = <ThrowOnError extends boolean = false>(
  options: Options<ListStudyAdherenceConfigsStudiesStudyIdAdherenceConfigGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListStudyAdherenceConfigsStudiesStudyIdAdherenceConfigGetResponse,
    ListStudyAdherenceConfigsStudiesStudyIdAdherenceConfigGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/adherence/config',
  })
}

/**
 * Create Study Adherence Config
 * Create a study adherence config.
 */
export const createStudyAdherenceConfigStudiesStudyIdAdherenceConfigPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateStudyAdherenceConfigStudiesStudyIdAdherenceConfigPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateStudyAdherenceConfigStudiesStudyIdAdherenceConfigPostResponse,
    CreateStudyAdherenceConfigStudiesStudyIdAdherenceConfigPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/adherence/config',
  })
}

/**
 * Get Study Adherence Config
 * Retrieve a study adherence config by its ID.
 */
export const getStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdGetResponse,
    GetStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/adherence/config/{studyadherenceconfig_id}',
  })
}

/**
 * Update Study Adherence Config
 * Update a study adherence config.
 */
export const updateStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdPutResponse,
    UpdateStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/adherence/config/{studyadherenceconfig_id}',
  })
}

/**
 * Delete Study Adherence Config
 * Delete a study adherence config.
 */
export const deleteStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdDeleteData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).delete<
    DeleteStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdDeleteResponse,
    DeleteStudyAdherenceConfigStudiesStudyIdAdherenceConfigStudyadherenceconfigIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/adherence/config/{studyadherenceconfig_id}',
  })
}

/**
 * Create Study Adherence Rule
 * Create a study adherence rule.
 */
export const createStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRulePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRulePostData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).post<
    CreateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRulePostResponse,
    CreateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRulePostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/adherence/config/{studyadherenceconfig_id}/rule',
  })
}

/**
 * Update Study Adherence Rule
 * Update a study adherence rule.
 */
export const updateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdPutData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).put<
    UpdateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdPutResponse,
    UpdateStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/adherence/config/{studyadherenceconfig_id}/rule/{studyadherencerule_id}',
  })
}

/**
 * Delete Study Adherence Rule
 * Delete a study adherence rule.
 */
export const deleteStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdDeleteData,
      ThrowOnError
    >,
  ) => {
    return (options?.client ?? client).delete<
      DeleteStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdDeleteResponse,
      DeleteStudyAdherenceRuleStudiesStudyIdAdherenceConfigStudyadherenceconfigIdRuleStudyadherenceruleIdDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/studies/{study_id}/adherence/config/{studyadherenceconfig_id}/rule/{studyadherencerule_id}',
    })
  }

/**
 * Check Study Adherence
 * Check study adherence.
 */
export const checkStudyAdherenceStudiesStudyIdAdherenceCheckRuleIdPost = <ThrowOnError extends boolean = false>(
  options: Options<CheckStudyAdherenceStudiesStudyIdAdherenceCheckRuleIdPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CheckStudyAdherenceStudiesStudyIdAdherenceCheckRuleIdPostResponse,
    CheckStudyAdherenceStudiesStudyIdAdherenceCheckRuleIdPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/adherence/check/{rule_id}',
  })
}

/**
 * Study Forms
 * Retrieve forms associated with a study.
 */
export const studyFormsStudiesStudyIdFormsGet = <ThrowOnError extends boolean = false>(
  options: Options<StudyFormsStudiesStudyIdFormsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    StudyFormsStudiesStudyIdFormsGetResponse,
    StudyFormsStudiesStudyIdFormsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/forms',
  })
}

/**
 * Create Study Form Definition
 * Create a new study form definition.
 */
export const createStudyFormDefinitionStudiesStudyIdFormsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateStudyFormDefinitionStudiesStudyIdFormsPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateStudyFormDefinitionStudiesStudyIdFormsPostResponse,
    CreateStudyFormDefinitionStudiesStudyIdFormsPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/forms',
  })
}

/**
 * Get Study Form By Id
 * Retrieve a study form definition by its ID.
 */
export const getStudyFormByIdStudiesStudyIdFormsStudyFormIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetStudyFormByIdStudiesStudyIdFormsStudyFormIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyFormByIdStudiesStudyIdFormsStudyFormIdGetResponse,
    GetStudyFormByIdStudiesStudyIdFormsStudyFormIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/forms/{study_form_id}',
  })
}

/**
 * Update Study Form Definition
 * Update an existing study form definition.
 */
export const updateStudyFormDefinitionStudiesStudyIdFormsStudyFormIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateStudyFormDefinitionStudiesStudyIdFormsStudyFormIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateStudyFormDefinitionStudiesStudyIdFormsStudyFormIdPutResponse,
    UpdateStudyFormDefinitionStudiesStudyIdFormsStudyFormIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/forms/{study_form_id}',
  })
}

/**
 * Delete Study Form Definition
 * Delete an existing study form defintion.
 */
export const deleteStudyFormDefinitionStudiesStudyIdFormsStudyFormIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteStudyFormDefinitionStudiesStudyIdFormsStudyFormIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteStudyFormDefinitionStudiesStudyIdFormsStudyFormIdDeleteResponse,
    DeleteStudyFormDefinitionStudiesStudyIdFormsStudyFormIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/forms/{study_form_id}',
  })
}

/**
 * Metadata
 * Get study metadata.
 */
export const metadataStudiesMetadataGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    MetadataStudiesMetadataGetResponse,
    MetadataStudiesMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/metadata',
  })
}

/**
 * Get Study Users Metadata
 */
export const getStudyUsersMetadataStudiesUsersMetadataGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyUsersMetadataStudiesUsersMetadataGetResponse,
    GetStudyUsersMetadataStudiesUsersMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/users/metadata',
  })
}

/**
 * Get Study Metadata
 * Retrieve study metadata by types.
 */
export const getStudyMetadataStudiesStudyIdMetadataGet = <ThrowOnError extends boolean = false>(
  options: Options<GetStudyMetadataStudiesStudyIdMetadataGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyMetadataStudiesStudyIdMetadataGetResponse,
    GetStudyMetadataStudiesStudyIdMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/metadata',
  })
}

/**
 * Get Dicom Tags
 * Retrieves dicom tags metadata
 */
export const getDicomTagsStudiesDicomTagsGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetDicomTagsStudiesDicomTagsGetResponse,
    GetDicomTagsStudiesDicomTagsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/dicom-tags',
  })
}

/**
 * Series Labels
 */
export const seriesLabelsStudiesSeriesLabelsGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    SeriesLabelsStudiesSeriesLabelsGetResponse,
    SeriesLabelsStudiesSeriesLabelsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/series-labels',
  })
}

/**
 * Create Draft Qc
 * Create a new draft qc.
 */
export const createDraftQcStudiesStudyIdQcDraftPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateDraftQcStudiesStudyIdQcDraftPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateDraftQcStudiesStudyIdQcDraftPostResponse,
    CreateDraftQcStudiesStudyIdQcDraftPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/qc/draft',
  })
}

/**
 * Create Qc
 * Create a new qc.
 */
export const createQcStudiesStudyIdQcPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateQcStudiesStudyIdQcPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateQcStudiesStudyIdQcPostResponse,
    CreateQcStudiesStudyIdQcPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/qc',
  })
}

/**
 * Get Qc
 * Get the assigned QC requirement for a study by study_id.
 */
export const getQcStudiesStudyIdQcGet = <ThrowOnError extends boolean = false>(
  options: Options<GetQcStudiesStudyIdQcGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetQcStudiesStudyIdQcGetResponse, GetQcStudiesStudyIdQcGetError, ThrowOnError>(
    {
      ...options,
      url: '/studies/{study_id}/qc',
    },
  )
}

/**
 * Update Draft Qc
 * Create a new draft qc.
 */
export const updateDraftQcStudiesStudyIdQcStudyQcRequirementIdDraftPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDraftQcStudiesStudyIdQcStudyQcRequirementIdDraftPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateDraftQcStudiesStudyIdQcStudyQcRequirementIdDraftPutResponse,
    UpdateDraftQcStudiesStudyIdQcStudyQcRequirementIdDraftPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/qc/{study_qc_requirement_id}/draft',
  })
}

/**
 * Update Qc
 * Create a new qc.
 */
export const updateQcStudiesStudyIdQcStudyQcRequirementIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateQcStudiesStudyIdQcStudyQcRequirementIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateQcStudiesStudyIdQcStudyQcRequirementIdPutResponse,
    UpdateQcStudiesStudyIdQcStudyQcRequirementIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/qc/{study_qc_requirement_id}',
  })
}

/**
 * Create Draft Read Design
 * Create a new draft read design.
 */
export const createDraftReadDesignStudiesStudyIdReadDesignDraftPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateDraftReadDesignStudiesStudyIdReadDesignDraftPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateDraftReadDesignStudiesStudyIdReadDesignDraftPostResponse,
    CreateDraftReadDesignStudiesStudyIdReadDesignDraftPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/read-design/draft',
  })
}

/**
 * Create Read Design
 * Create a new read design.
 */
export const createReadDesignStudiesStudyIdReadDesignPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateReadDesignStudiesStudyIdReadDesignPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateReadDesignStudiesStudyIdReadDesignPostResponse,
    CreateReadDesignStudiesStudyIdReadDesignPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/read-design',
  })
}

/**
 * Get Study Read Designs
 * Retrieve all read designs for a study.
 */
export const getStudyReadDesignsStudiesStudyIdReadDesignsGet = <ThrowOnError extends boolean = false>(
  options: Options<GetStudyReadDesignsStudiesStudyIdReadDesignsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyReadDesignsStudiesStudyIdReadDesignsGetResponse,
    GetStudyReadDesignsStudiesStudyIdReadDesignsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/read-designs',
  })
}

/**
 * Get Study Read Design By Id
 * Retrieve a specific read design by ID.
 */
export const getStudyReadDesignByIdStudiesStudyIdReadDesignReadDesignIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetStudyReadDesignByIdStudiesStudyIdReadDesignReadDesignIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyReadDesignByIdStudiesStudyIdReadDesignReadDesignIdGetResponse,
    GetStudyReadDesignByIdStudiesStudyIdReadDesignReadDesignIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/read-design/{read_design_id}',
  })
}

/**
 * Delete Read Design
 * Delete a specific read design.
 */
export const deleteReadDesignStudiesStudyIdReadDesignReadDesignIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteReadDesignStudiesStudyIdReadDesignReadDesignIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteReadDesignStudiesStudyIdReadDesignReadDesignIdDeleteResponse,
    DeleteReadDesignStudiesStudyIdReadDesignReadDesignIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/read-design/{read_design_id}',
  })
}

/**
 * Update Read Design
 * Update a read design.
 */
export const updateReadDesignStudiesStudyIdReadDesignReadDesignIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReadDesignStudiesStudyIdReadDesignReadDesignIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateReadDesignStudiesStudyIdReadDesignReadDesignIdPutResponse,
    UpdateReadDesignStudiesStudyIdReadDesignReadDesignIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/read-design/{read_design_id}',
  })
}

/**
 * Update Draft Read Design
 * Update a draft read design.
 */
export const updateDraftReadDesignStudiesStudyIdReadDesignReadDesignIdDraftPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDraftReadDesignStudiesStudyIdReadDesignReadDesignIdDraftPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateDraftReadDesignStudiesStudyIdReadDesignReadDesignIdDraftPutResponse,
    UpdateDraftReadDesignStudiesStudyIdReadDesignReadDesignIdDraftPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/read-design/{read_design_id}/draft',
  })
}

/**
 * Get Study Homepage
 * Get study homepage with pagination and ordering.
 */
export const getStudyHomepageStudiesHomepageGet = <ThrowOnError extends boolean = false>(
  options: Options<GetStudyHomepageStudiesHomepageGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyHomepageStudiesHomepageGetResponse,
    GetStudyHomepageStudiesHomepageGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/homepage',
  })
}

/**
 * Get Study By Id
 * Retrieve a study by its ID.
 */
export const getStudyByIdStudiesStudyIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetStudyByIdStudiesStudyIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyByIdStudiesStudyIdGetResponse,
    GetStudyByIdStudiesStudyIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}',
  })
}

/**
 * Update Study
 * Update an existing study.
 */
export const updateStudyStudiesStudyIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateStudyStudiesStudyIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateStudyStudiesStudyIdPutResponse,
    UpdateStudyStudiesStudyIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}',
  })
}

/**
 * Parial Update Study
 * Update an existing study.
 */
export const parialUpdateStudyStudiesStudyIdPatch = <ThrowOnError extends boolean = false>(
  options: Options<ParialUpdateStudyStudiesStudyIdPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    ParialUpdateStudyStudiesStudyIdPatchResponse,
    ParialUpdateStudyStudiesStudyIdPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}',
  })
}

/**
 * Create Study
 * Create a new study.
 */
export const createStudyStudiesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateStudyStudiesPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<CreateStudyStudiesPostResponse, CreateStudyStudiesPostError, ThrowOnError>({
    ...options,
    url: '/studies/',
  })
}

/**
 * Create Draft Study
 * Create a new draft study.
 */
export const createDraftStudyStudiesDraftPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateDraftStudyStudiesDraftPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateDraftStudyStudiesDraftPostResponse,
    CreateDraftStudyStudiesDraftPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/draft',
  })
}

/**
 * Update Draft Study
 * Update an existing draft study.
 */
export const updateDraftStudyStudiesDraftStudyIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDraftStudyStudiesDraftStudyIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateDraftStudyStudiesDraftStudyIdPutResponse,
    UpdateDraftStudyStudiesDraftStudyIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/draft/{study_id}',
  })
}

/**
 * Details
 */
export const detailsStudiesStudyIdDetailsGet = <ThrowOnError extends boolean = false>(
  options: Options<DetailsStudiesStudyIdDetailsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    DetailsStudiesStudyIdDetailsGetResponse,
    DetailsStudiesStudyIdDetailsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/details',
  })
}

/**
 * Promote Study Status
 * Promote study to next status.
 */
export const promoteStudyStatusStudiesStudyIdPromotePatch = <ThrowOnError extends boolean = false>(
  options: Options<PromoteStudyStatusStudiesStudyIdPromotePatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    PromoteStudyStatusStudiesStudyIdPromotePatchResponse,
    PromoteStudyStatusStudiesStudyIdPromotePatchError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/promote',
  })
}

/**
 * Export Study Setup
 * Export study setup as a JSON file that can be imported into another environment.
 */
export const exportStudySetupStudiesStudyIdExportStudySetupGet = <ThrowOnError extends boolean = false>(
  options: Options<ExportStudySetupStudiesStudyIdExportStudySetupGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ExportStudySetupStudiesStudyIdExportStudySetupGetResponse,
    ExportStudySetupStudiesStudyIdExportStudySetupGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/export-study-setup/',
  })
}

/**
 * Import Study Setup
 * Import study setup from a JSON export file.
 */
export const importStudySetupStudiesImportStudySetupPost = <ThrowOnError extends boolean = false>(
  options: Options<ImportStudySetupStudiesImportStudySetupPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ImportStudySetupStudiesImportStudySetupPostResponse,
    ImportStudySetupStudiesImportStudySetupPostError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
    },
    url: '/studies/import-study-setup/',
  })
}

/**
 * Study Tags
 * Retrieve DICOM tags associated with a study.
 */
export const studyTagsStudiesStudyIdTagsDeidGet = <ThrowOnError extends boolean = false>(
  options: Options<StudyTagsStudiesStudyIdTagsDeidGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    StudyTagsStudiesStudyIdTagsDeidGetResponse,
    StudyTagsStudiesStudyIdTagsDeidGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/tags-deid',
  })
}

/**
 * Create Study Tag
 * Create a new studydicom tag.
 */
export const createStudyTagStudiesStudyIdTagsDeidPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateStudyTagStudiesStudyIdTagsDeidPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateStudyTagStudiesStudyIdTagsDeidPostResponse,
    CreateStudyTagStudiesStudyIdTagsDeidPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/tags-deid',
  })
}

/**
 * Get Study Tag By Id
 * Retrieve a study DICOM Tag by its ID.
 */
export const getStudyTagByIdStudiesStudyIdTagsDeidStudyTagIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetStudyTagByIdStudiesStudyIdTagsDeidStudyTagIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyTagByIdStudiesStudyIdTagsDeidStudyTagIdGetResponse,
    GetStudyTagByIdStudiesStudyIdTagsDeidStudyTagIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/tags-deid/{study_tag_id}',
  })
}

/**
 * Update Study Tag
 * Update an existing study dicom tag.
 */
export const updateStudyTagStudiesStudyIdTagsDeidStudyTagIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateStudyTagStudiesStudyIdTagsDeidStudyTagIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateStudyTagStudiesStudyIdTagsDeidStudyTagIdPutResponse,
    UpdateStudyTagStudiesStudyIdTagsDeidStudyTagIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/tags-deid/{study_tag_id}',
  })
}

/**
 * Delete Study Tag
 * Delete an existing study tag.
 */
export const deleteStudyTagStudiesStudyIdTagsDeidStudyTagIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteStudyTagStudiesStudyIdTagsDeidStudyTagIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteStudyTagStudiesStudyIdTagsDeidStudyTagIdDeleteResponse,
    DeleteStudyTagStudiesStudyIdTagsDeidStudyTagIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/tags-deid/{study_tag_id}',
  })
}

/**
 * Create Timepoint
 * Create a new study timepoint.
 */
export const createTimepointStudiesStudyIdTimepointPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateTimepointStudiesStudyIdTimepointPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateTimepointStudiesStudyIdTimepointPostResponse,
    CreateTimepointStudiesStudyIdTimepointPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/timepoint',
  })
}

/**
 * Update Timepoint
 * Update an existing study timepoint.
 */
export const updateTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdPutResponse,
    UpdateTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/timepoint/{study_timepoint_requirement_id}',
  })
}

/**
 * Delete Timepoint
 * Delete an existing study timepoint.
 */
export const deleteTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDeleteResponse,
    DeleteTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/timepoint/{study_timepoint_requirement_id}',
  })
}

/**
 * Get Study Timepoint By Id
 * Retrieve a study by its ID.
 */
export const getStudyTimepointByIdStudiesStudyIdTimepointStudyTimepointRequirementIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetStudyTimepointByIdStudiesStudyIdTimepointStudyTimepointRequirementIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyTimepointByIdStudiesStudyIdTimepointStudyTimepointRequirementIdGetResponse,
    GetStudyTimepointByIdStudiesStudyIdTimepointStudyTimepointRequirementIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/timepoint/{study_timepoint_requirement_id}',
  })
}

/**
 * Create Draft Timepoint
 * Create a new draft study timepoint.
 */
export const createDraftTimepointStudiesStudyIdTimepointDraftPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateDraftTimepointStudiesStudyIdTimepointDraftPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateDraftTimepointStudiesStudyIdTimepointDraftPostResponse,
    CreateDraftTimepointStudiesStudyIdTimepointDraftPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/timepoint/draft',
  })
}

/**
 * Update Draft Timepoint
 * update draft study timepoint.
 */
export const updateDraftTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDraftPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateDraftTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDraftPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateDraftTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDraftPutResponse,
    UpdateDraftTimepointStudiesStudyIdTimepointStudyTimepointRequirementIdDraftPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/timepoint/{study_timepoint_requirement_id}/draft',
  })
}

/**
 * Get Study Timepoints
 * Retrieve all timepoints associated with a study.
 */
export const getStudyTimepointsStudiesStudyIdTimepointsGet = <ThrowOnError extends boolean = false>(
  options: Options<GetStudyTimepointsStudiesStudyIdTimepointsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyTimepointsStudiesStudyIdTimepointsGetResponse,
    GetStudyTimepointsStudiesStudyIdTimepointsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/timepoints',
  })
}

/**
 * Get Timepoint Container Upload Types
 * Retrieve all non-DICOM upload types for timepoint containers associated with a study's timepoints.
 */
export const getTimepointContainerUploadTypesStudiesStudyIdTimepointsUploadTypesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTimepointContainerUploadTypesStudiesStudyIdTimepointsUploadTypesGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTimepointContainerUploadTypesStudiesStudyIdTimepointsUploadTypesGetResponse,
    GetTimepointContainerUploadTypesStudiesStudyIdTimepointsUploadTypesGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/timepoints/upload-types',
  })
}

/**
 * @deprecated
 * Create Subject
 * Create a new Study Subject for a site
 */
export const createSubjectStudiesStudyIdSiteSiteIdSubjectsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateSubjectStudiesStudyIdSiteSiteIdSubjectsPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateSubjectStudiesStudyIdSiteSiteIdSubjectsPostResponse,
    CreateSubjectStudiesStudyIdSiteSiteIdSubjectsPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/site/{site_id}/subjects',
  })
}

/**
 * Create Timepoint Submission
 * Create a new Timepoint Submission for a subject
 */
export const createTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPostResponse,
    CreateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects/{subject_id}/timepoint_submission',
  })
}

/**
 * Get Timepoint Submission
 */
export const getTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdGetData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).get<
    GetTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdGetResponse,
    GetTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects/{subject_id}/timepoint_submission/{timepoint_submission_id}',
  })
}

/**
 * Update Timepoint Submission
 * Update a Timepoint Submission for a subject
 */
export const updateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdPatchData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).patch<
    UpdateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdPatchResponse,
    UpdateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects/{subject_id}/timepoint_submission/{timepoint_submission_id}',
  })
}

/**
 * Update Timepoint Container Submission
 * Update a Timepoint Container Submission for a subject
 */
export const updateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatchData,
      ThrowOnError
    >,
  ) => {
    return (options?.client ?? client).patch<
      UpdateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatchResponse,
      UpdateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatchError,
      ThrowOnError
    >({
      ...options,
      url: '/studies/{study_id}/subjects/{subject_id}/timepoint_submission/{timepoint_submission_id}/container_submissions',
    })
  }

/**
 * Get All Subjects Timepoints
 * Get all timepoint details for subjects in a study
 */
export const getAllSubjectsTimepointsStudiesStudyIdSubjectsTimepointsGet = <ThrowOnError extends boolean = false>(
  options: Options<GetAllSubjectsTimepointsStudiesStudyIdSubjectsTimepointsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAllSubjectsTimepointsStudiesStudyIdSubjectsTimepointsGetResponse,
    GetAllSubjectsTimepointsStudiesStudyIdSubjectsTimepointsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects/timepoints',
  })
}

/**
 * Get Subject Timepoints
 */
export const getSubjectTimepointsStudiesStudyIdSubjectsSubjectIdTimepointsGet = <ThrowOnError extends boolean = false>(
  options: Options<GetSubjectTimepointsStudiesStudyIdSubjectsSubjectIdTimepointsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSubjectTimepointsStudiesStudyIdSubjectsSubjectIdTimepointsGetResponse,
    GetSubjectTimepointsStudiesStudyIdSubjectsSubjectIdTimepointsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects/{subject_id}/timepoints',
  })
}

/**
 * Get Timepoint Exam Reassignment Check
 * Get timepoint submission IDs with no read tasks in specified statuses.
 */
export const getTimepointExamReassignmentCheckStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignCheckGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetTimepointExamReassignmentCheckStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignCheckGetData,
      ThrowOnError
    >,
  ) => {
    return (options?.client ?? client).get<
      GetTimepointExamReassignmentCheckStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignCheckGetResponse,
      GetTimepointExamReassignmentCheckStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignCheckGetError,
      ThrowOnError
    >({
      ...options,
      url: '/studies/{study_id}/subjects/{subject_id}/timepoint_submission/{timepoint_submission_id}/exam_reassign/check',
    })
  }

/**
 * Get Timepoint Exam Reassignment Preview
 * Preview the reassignment of exams from one timepoint to another.
 */
export const getTimepointExamReassignmentPreviewStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignPreviewGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetTimepointExamReassignmentPreviewStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignPreviewGetData,
      ThrowOnError
    >,
  ) => {
    return (options?.client ?? client).get<
      GetTimepointExamReassignmentPreviewStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignPreviewGetResponse,
      GetTimepointExamReassignmentPreviewStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignPreviewGetError,
      ThrowOnError
    >({
      ...options,
      url: '/studies/{study_id}/subjects/{subject_id}/timepoint_submission/{timepoint_submission_id}/exam_reassign/preview',
    })
  }

/**
 * Get Timepoint Exam Reassignment Esign
 * Esign the reassignment of exams from one timepoint to another.
 */
export const getTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPostData,
      ThrowOnError
    >,
  ) => {
    return (options?.client ?? client).post<
      GetTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPostResponse,
      GetTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPostError,
      ThrowOnError
    >({
      ...options,
      url: '/studies/{study_id}/subjects/{subject_id}/timepoint_submission/{timepoint_submission_id}/exam_reassign/esign',
    })
  }

/**
 * Get Subject Reassignment Esign
 * Esign the reassignment of data from one timepoint to another.
 */
export const getSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPostResponse,
    GetSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects/{subject_id}/subject_reassign',
  })
}

/**
 * Download-Exam
 * Download exam metadata for a specific container submission.
 */
export const downloadExamStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamDownloadGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DownloadExamStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamDownloadGetData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).get<
    DownloadExamStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamDownloadGetResponse,
    DownloadExamStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamDownloadGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects/{subject_id}/timepoint_submission/{timepoint_submission_id}/exam_download',
  })
}

/**
 * Update Additional Comments
 */
export const updateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatchResponse,
    UpdateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/additional_comments',
  })
}

/**
 * Capture eSign details for a timepoint submission
 */
export const timepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      TimepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPostData,
      ThrowOnError
    >,
  ) => {
    return (options?.client ?? client).post<
      TimepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPostResponse,
      TimepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPostError,
      ThrowOnError
    >({
      ...options,
      url: '/studies/{study_id}/subjects/{subject_id}/timepoint_submission/{timepoint_submission_id}/esign',
    })
  }

/**
 * List Study Subject Configuration
 * List study subject configurations.
 */
export const listStudySubjectConfigurationStudiesStudyIdSubjectConfigurationGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListStudySubjectConfigurationStudiesStudyIdSubjectConfigurationGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListStudySubjectConfigurationStudiesStudyIdSubjectConfigurationGetResponse,
    ListStudySubjectConfigurationStudiesStudyIdSubjectConfigurationGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subject-configuration',
  })
}

/**
 * Create Study Subject Configuration
 * Create study subject configuration.
 */
export const createStudySubjectConfigurationStudiesStudyIdSubjectConfigurationPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationPostResponse,
    CreateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subject-configuration',
  })
}

/**
 * Create Study Subject Configuration Draft
 * Create study subject configuration DRAFT.
 */
export const createStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationDraftPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationDraftPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationDraftPostResponse,
    CreateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationDraftPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subject-configuration/draft',
  })
}

/**
 * Update Study Subject Configuration
 * Update study subject configuration.
 */
export const updateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationSubjectConfigurationIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationSubjectConfigurationIdPutData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).put<
    UpdateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationSubjectConfigurationIdPutResponse,
    UpdateStudySubjectConfigurationStudiesStudyIdSubjectConfigurationSubjectConfigurationIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subject-configuration/{subject_configuration_id}',
  })
}

/**
 * Update Study Subject Configuration Draft
 * Update study subject configuration DRAFT.
 */
export const updateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationSubjectConfigurationIdDraftPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationSubjectConfigurationIdDraftPutData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).put<
    UpdateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationSubjectConfigurationIdDraftPutResponse,
    UpdateStudySubjectConfigurationDraftStudiesStudyIdSubjectConfigurationSubjectConfigurationIdDraftPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subject-configuration/{subject_configuration_id}/draft',
  })
}

/**
 * List Study Users
 */
export const listStudyUsersStudiesStudyIdUsersGet = <ThrowOnError extends boolean = false>(
  options: Options<ListStudyUsersStudiesStudyIdUsersGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListStudyUsersStudiesStudyIdUsersGetResponse,
    ListStudyUsersStudiesStudyIdUsersGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/users',
  })
}

/**
 * Add Study User
 */
export const addStudyUserStudiesStudyIdUsersPost = <ThrowOnError extends boolean = false>(
  options: Options<AddStudyUserStudiesStudyIdUsersPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AddStudyUserStudiesStudyIdUsersPostResponse,
    AddStudyUserStudiesStudyIdUsersPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/users',
  })
}

/**
 * Assign Users To Study
 */
export const assignUsersToStudyStudiesStudyIdUsersAssignPost = <ThrowOnError extends boolean = false>(
  options: Options<AssignUsersToStudyStudiesStudyIdUsersAssignPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AssignUsersToStudyStudiesStudyIdUsersAssignPostResponse,
    AssignUsersToStudyStudiesStudyIdUsersAssignPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/users/assign',
  })
}

/**
 * Unassign User From Study
 */
export const unassignUserFromStudyStudiesStudyIdUsersUserIdAssignDelete = <ThrowOnError extends boolean = false>(
  options: Options<UnassignUserFromStudyStudiesStudyIdUsersUserIdAssignDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    UnassignUserFromStudyStudiesStudyIdUsersUserIdAssignDeleteResponse,
    UnassignUserFromStudyStudiesStudyIdUsersUserIdAssignDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/users/{user_id}/assign',
  })
}

/**
 * Update Study User
 */
export const updateStudyUserStudiesStudyIdUsersUserIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateStudyUserStudiesStudyIdUsersUserIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateStudyUserStudiesStudyIdUsersUserIdPutResponse,
    UpdateStudyUserStudiesStudyIdUsersUserIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/users/{user_id}',
  })
}

/**
 * List Study Sites
 * List study sites
 */
export const listStudySitesStudiesStudyIdSitesGet = <ThrowOnError extends boolean = false>(
  options: Options<ListStudySitesStudiesStudyIdSitesGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListStudySitesStudiesStudyIdSitesGetResponse,
    ListStudySitesStudiesStudyIdSitesGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/sites',
  })
}

/**
 * Create Study Site
 * Create a new study site.
 */
export const createStudySiteStudiesStudyIdSitesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateStudySiteStudiesStudyIdSitesPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateStudySiteStudiesStudyIdSitesPostResponse,
    CreateStudySiteStudiesStudyIdSitesPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/sites',
  })
}

/**
 * Delete Study Sites
 * Bulk delete study sites.
 */
export const deleteStudySitesStudiesStudyIdSitesDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteStudySitesStudiesStudyIdSitesDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteStudySitesStudiesStudyIdSitesDeleteResponse,
    DeleteStudySitesStudiesStudyIdSitesDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/sites',
  })
}

/**
 * Get Study Sites Metadata
 * List study sites
 */
export const getStudySitesMetadataStudiesStudyIdSitesMetadataGet = <ThrowOnError extends boolean = false>(
  options: Options<GetStudySitesMetadataStudiesStudyIdSitesMetadataGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudySitesMetadataStudiesStudyIdSitesMetadataGetResponse,
    GetStudySitesMetadataStudiesStudyIdSitesMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/sites/metadata',
  })
}

/**
 * Get My Study Site
 * View study site for requesting user
 */
export const getMyStudySiteStudiesStudyIdSitesMySiteGet = <ThrowOnError extends boolean = false>(
  options: Options<GetMyStudySiteStudiesStudyIdSitesMySiteGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMyStudySiteStudiesStudyIdSitesMySiteGetResponse,
    GetMyStudySiteStudiesStudyIdSitesMySiteGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/sites/my-site',
  })
}

/**
 * Get Study Site By Id
 * List study sites
 */
export const getStudySiteByIdStudiesStudyIdSitesSiteIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetStudySiteByIdStudiesStudyIdSitesSiteIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudySiteByIdStudiesStudyIdSitesSiteIdGetResponse,
    GetStudySiteByIdStudiesStudyIdSitesSiteIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/sites/{site_id}',
  })
}

/**
 * Update Study Site
 * Update an existing study site.
 */
export const updateStudySiteStudiesStudyIdSitesSiteIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateStudySiteStudiesStudyIdSitesSiteIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateStudySiteStudiesStudyIdSitesSiteIdPutResponse,
    UpdateStudySiteStudiesStudyIdSitesSiteIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/sites/{site_id}',
  })
}

/**
 * Delete Study Site
 * Delete a study site.
 */
export const deleteStudySiteStudiesStudyIdSitesSiteIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteStudySiteStudiesStudyIdSitesSiteIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteStudySiteStudiesStudyIdSitesSiteIdDeleteResponse,
    DeleteStudySiteStudiesStudyIdSitesSiteIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/sites/{site_id}',
  })
}

/**
 * List Subjects
 */
export const listSubjectsStudiesStudyIdSubjectsGet = <ThrowOnError extends boolean = false>(
  options: Options<ListSubjectsStudiesStudyIdSubjectsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListSubjectsStudiesStudyIdSubjectsGetResponse,
    ListSubjectsStudiesStudyIdSubjectsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects',
  })
}

/**
 * Create Subject
 */
export const createSubjectStudiesStudyIdSubjectsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateSubjectStudiesStudyIdSubjectsPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateSubjectStudiesStudyIdSubjectsPostResponse,
    CreateSubjectStudiesStudyIdSubjectsPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects',
  })
}

/**
 * List Metadata
 */
export const listMetadataStudiesStudyIdSubjectsMetadataGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListMetadataStudiesStudyIdSubjectsMetadataGetResponse,
    ListMetadataStudiesStudyIdSubjectsMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects/metadata',
  })
}

/**
 * View Subject
 */
export const viewSubjectStudiesStudyIdSubjectsSubjectIdGet = <ThrowOnError extends boolean = false>(
  options: Options<ViewSubjectStudiesStudyIdSubjectsSubjectIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ViewSubjectStudiesStudyIdSubjectsSubjectIdGetResponse,
    ViewSubjectStudiesStudyIdSubjectsSubjectIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects/{subject_id}',
  })
}

/**
 * Update Subject
 */
export const updateSubjectStudiesStudyIdSubjectsSubjectIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSubjectStudiesStudyIdSubjectsSubjectIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateSubjectStudiesStudyIdSubjectsSubjectIdPutResponse,
    UpdateSubjectStudiesStudyIdSubjectsSubjectIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects/{subject_id}',
  })
}

/**
 * Bulk Create Subjects
 */
export const bulkCreateSubjectsStudiesStudyIdSubjectsBulkCreatePost = <ThrowOnError extends boolean = false>(
  options: Options<BulkCreateSubjectsStudiesStudyIdSubjectsBulkCreatePostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BulkCreateSubjectsStudiesStudyIdSubjectsBulkCreatePostResponse,
    BulkCreateSubjectsStudiesStudyIdSubjectsBulkCreatePostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/subjects/bulk_create',
  })
}

/**
 * Download-Dicom
 * Get DICOM download URL for a specific container submission
 */
export const downloadDicomStudiesSiteDownloadDicomGet = <ThrowOnError extends boolean = false>(
  options: Options<DownloadDicomStudiesSiteDownloadDicomGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    DownloadDicomStudiesSiteDownloadDicomGetResponse,
    DownloadDicomStudiesSiteDownloadDicomGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/site/download-dicom',
  })
}

/**
 * Non-Dicom-File
 * Get a short-lived, content-typed URL for viewing or downloading a single non-DICOM file.
 *
 * The MIME type and whether the file may be rendered inline are decided server side from an
 * allowlist; the caller cannot influence either.
 */
export const nonDicomFileStudiesSiteNonDicomFileGet = <ThrowOnError extends boolean = false>(
  options: Options<NonDicomFileStudiesSiteNonDicomFileGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    NonDicomFileStudiesSiteNonDicomFileGetResponse,
    NonDicomFileStudiesSiteNonDicomFileGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/site/non-dicom-file',
  })
}

/**
 * Timepoint Submission:Dicom Metadata
 * Retrieves the dicom metadata based on study id, subject id and timepoint submission id.
 */
export const timepointSubmissionDicomMetadataStudiesSiteDicomMetadataGet = <ThrowOnError extends boolean = false>(
  options: Options<TimepointSubmissionDicomMetadataStudiesSiteDicomMetadataGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    TimepointSubmissionDicomMetadataStudiesSiteDicomMetadataGetResponse,
    TimepointSubmissionDicomMetadataStudiesSiteDicomMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/site/dicom_metadata',
  })
}

/**
 * Get Reports
 */
export const getReportsStudiesStudyIdReportsReportTypeGet = <ThrowOnError extends boolean = false>(
  options: Options<GetReportsStudiesStudyIdReportsReportTypeGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetReportsStudiesStudyIdReportsReportTypeGetResponse,
    GetReportsStudiesStudyIdReportsReportTypeGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/reports/{report_type}',
  })
}

/**
 * Download Qc Report
 */
export const downloadQcReportStudiesStudyIdReportsQcReportTypeDownloadPost = <ThrowOnError extends boolean = false>(
  options: Options<DownloadQcReportStudiesStudyIdReportsQcReportTypeDownloadPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DownloadQcReportStudiesStudyIdReportsQcReportTypeDownloadPostResponse,
    DownloadQcReportStudiesStudyIdReportsQcReportTypeDownloadPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/reports/qc/{report_type}/download',
  })
}

/**
 * Download Timepoint Eform Report
 */
export const downloadTimepointEformReportStudiesStudyIdReportsTimepointEformReportTypeDownloadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DownloadTimepointEformReportStudiesStudyIdReportsTimepointEformReportTypeDownloadPostData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).post<
    DownloadTimepointEformReportStudiesStudyIdReportsTimepointEformReportTypeDownloadPostResponse,
    DownloadTimepointEformReportStudiesStudyIdReportsTimepointEformReportTypeDownloadPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/reports/timepoint-eform/{report_type}/download',
  })
}

/**
 * Download General Report
 */
export const downloadGeneralReportStudiesStudyIdReportsGeneralReportTypeDownloadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DownloadGeneralReportStudiesStudyIdReportsGeneralReportTypeDownloadPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DownloadGeneralReportStudiesStudyIdReportsGeneralReportTypeDownloadPostResponse,
    DownloadGeneralReportStudiesStudyIdReportsGeneralReportTypeDownloadPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/reports/general/{report_type}/download',
  })
}

/**
 * Download Ecrf Report
 */
export const downloadEcrfReportStudiesStudyIdReportsEcrfReportNameDownloadPost = <ThrowOnError extends boolean = false>(
  options: Options<DownloadEcrfReportStudiesStudyIdReportsEcrfReportNameDownloadPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DownloadEcrfReportStudiesStudyIdReportsEcrfReportNameDownloadPostResponse,
    DownloadEcrfReportStudiesStudyIdReportsEcrfReportNameDownloadPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/reports/ecrf/{report_name}/download',
  })
}

/**
 * Generate Ecrf Report
 * Generate an XML eCRF report for a specific read task submission.
 * Returns the report as plain text XML.
 */
export const generateEcrfReportStudiesStudyIdSubmissionsSubmissionIdEcrfReportPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateEcrfReportStudiesStudyIdSubmissionsSubmissionIdEcrfReportPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GenerateEcrfReportStudiesStudyIdSubmissionsSubmissionIdEcrfReportPostResponse,
    GenerateEcrfReportStudiesStudyIdSubmissionsSubmissionIdEcrfReportPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/submissions/{submission_id}/ecrf_report',
  })
}

/**
 * Get Phi Redaction Status
 * Get the status of all PHI redaction jobs for multiple container submissions.
 *
 * Args:
 * study_id: Study ID
 * subject_id: Subject ID
 * timepoint_submission_id: Timepoint submission ID
 * container_submission_ids: List of container submission IDs to check status for
 * service: PHI redaction service dependency
 *
 * Returns:
 * PHIRedactionStatusResponse containing status for all containers and their predictions if completed
 */
export const getPhiRedactionStatusStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionStatusGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPhiRedactionStatusStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionStatusGetData,
      ThrowOnError
    >,
  ) => {
    return (options?.client ?? client).get<
      GetPhiRedactionStatusStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionStatusGetResponse,
      GetPhiRedactionStatusStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionStatusGetError,
      ThrowOnError
    >({
      ...options,
      url: '/studies/{study_id}/subjects/{subject_id}/timepoint_submissions/{timepoint_submission_id}/phi-redaction/status',
    })
  }

/**
 * List Study Queries
 * Retrieves a paginated list of study queries for the given study. Filters based on user permissions (all vs. site-specific).
 */
export const listStudyQueriesStudiesStudyIdQueriesGet = <ThrowOnError extends boolean = false>(
  options: Options<ListStudyQueriesStudiesStudyIdQueriesGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListStudyQueriesStudiesStudyIdQueriesGetResponse,
    ListStudyQueriesStudiesStudyIdQueriesGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/queries/',
  })
}

/**
 * Create Study Query
 * Creates a new study query and its initial message.
 */
export const createStudyQueryStudiesStudyIdQueriesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateStudyQueryStudiesStudyIdQueriesPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateStudyQueryStudiesStudyIdQueriesPostResponse,
    CreateStudyQueryStudiesStudyIdQueriesPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/queries/',
  })
}

/**
 * Delete Multiple Study Queries (Soft)
 * Marks multiple study queries as deleted.
 */
export const bulkDeleteStudyQueriesStudiesStudyIdQueriesDelete = <ThrowOnError extends boolean = false>(
  options: Options<BulkDeleteStudyQueriesStudiesStudyIdQueriesDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    BulkDeleteStudyQueriesStudiesStudyIdQueriesDeleteResponse,
    BulkDeleteStudyQueriesStudiesStudyIdQueriesDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/queries/',
  })
}

/**
 * Get Query Metadata
 * Retrieves metadata needed for creating study queries (e.g., for dropdowns).
 */
export const getQueryMetadataStudiesStudyIdQueriesMetadataGet = <ThrowOnError extends boolean = false>(
  options: Options<GetQueryMetadataStudiesStudyIdQueriesMetadataGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetQueryMetadataStudiesStudyIdQueriesMetadataGetResponse,
    GetQueryMetadataStudiesStudyIdQueriesMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/queries/metadata',
  })
}

/**
 * Get Study Query Details
 * Retrieves detailed information for a specific study query.
 */
export const getStudyQueryStudiesStudyIdQueriesStudyQueryIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetStudyQueryStudiesStudyIdQueriesStudyQueryIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyQueryStudiesStudyIdQueriesStudyQueryIdGetResponse,
    GetStudyQueryStudiesStudyIdQueriesStudyQueryIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/queries/{study_query_id}',
  })
}

/**
 * Update Study Query Associations
 * Updates assignees, CC users, and linked container submissions for a query.
 */
export const updateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatchResponse,
    UpdateStudyQueryStudiesStudyIdQueriesStudyQueryIdPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/queries/{study_query_id}',
  })
}

/**
 * Delete Study Query (Soft)
 * Marks a study query as deleted.
 */
export const deleteStudyQueryStudiesStudyIdQueriesStudyQueryIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteStudyQueryStudiesStudyIdQueriesStudyQueryIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteStudyQueryStudiesStudyIdQueriesStudyQueryIdDeleteResponse,
    DeleteStudyQueryStudiesStudyIdQueriesStudyQueryIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/queries/{study_query_id}',
  })
}

/**
 * Update Study Query Status
 * Updates the status (and optionally reason) of a study query.
 */
export const updateStudyQueryStatusStudiesStudyIdQueriesStudyQueryIdUpdateStatusPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateStudyQueryStatusStudiesStudyIdQueriesStudyQueryIdUpdateStatusPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateStudyQueryStatusStudiesStudyIdQueriesStudyQueryIdUpdateStatusPatchResponse,
    UpdateStudyQueryStatusStudiesStudyIdQueriesStudyQueryIdUpdateStatusPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/queries/{study_query_id}/update-status',
  })
}

/**
 * Add Query Message
 * Adds a message to the specified study query's conversation thread.
 */
export const addQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPost = <ThrowOnError extends boolean = false>(
  options: Options<AddQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AddQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPostResponse,
    AddQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPostError,
    ThrowOnError
  >({
    ...options,
    url: '/studies/{study_id}/queries/{study_query_id}/messages',
  })
}
/* Update Phi Redaction Bounding Boxes
 * Update PHI redaction bounding boxes for multiple containers in a timepoint submission.
 *
 * This endpoint allows applying or removing PHI redaction bounding boxes with flexible scope:
 * - Each container can have multiple updates
 * - Action "apply": Adds new bounding boxes after removing any existing ones
 * (replaces all existing boxes with the provided ones)
 * - Action "remove": Removes all existing bounding boxes
 * - Scope "single": Affects a single SOP instance
 * - Scope "all": Affects all SOP instances in the series
 *
 * Args:
 * study_id: Study ID
 * subject_id: Subject ID
 * timepoint_submission_id: Timepoint submission ID
 * request: Request containing the container updates to apply
 * service: PHI redaction service dependency
 *
 * Returns:
 * The updated PHI redaction status for the affected containers, including latest predictions.
 */
export const updatePhiRedactionBoundingBoxesStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionBoundingBoxesPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdatePhiRedactionBoundingBoxesStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionBoundingBoxesPutData,
      ThrowOnError
    >,
  ) => {
    return (options?.client ?? client).put<
      UpdatePhiRedactionBoundingBoxesStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionBoundingBoxesPutResponse,
      UpdatePhiRedactionBoundingBoxesStudiesStudyIdSubjectsSubjectIdTimepointSubmissionsTimepointSubmissionIdPhiRedactionBoundingBoxesPutError,
      ThrowOnError
    >({
      ...options,
      url: '/studies/{study_id}/subjects/{subject_id}/timepoint_submissions/{timepoint_submission_id}/phi-redaction/bounding-boxes',
    })
  }

/**
 * Load Fixtures
 * Load fixtures from the specified YAML files into the database.
 */
export const loadFixturesFixturesLoadPost = <ThrowOnError extends boolean = false>(
  options: Options<LoadFixturesFixturesLoadPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    LoadFixturesFixturesLoadPostResponse,
    LoadFixturesFixturesLoadPostError,
    ThrowOnError
  >({
    ...options,
    url: '/fixtures/load',
  })
}

/**
 * Delete Fixtures
 * Delete fixtures in the uploaded YAML from the database.
 */
export const deleteFixturesFixturesDeletePost = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFixturesFixturesDeletePostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteFixturesFixturesDeletePostResponse,
    DeleteFixturesFixturesDeletePostError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
    },
    url: '/fixtures/delete',
  })
}

/**
 * Upload Fixtures
 * Load fixtures from the uploaded YAML file into the database.
 */
export const uploadFixturesFixturesUploadPost = <ThrowOnError extends boolean = false>(
  options: Options<UploadFixturesFixturesUploadPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UploadFixturesFixturesUploadPostResponse,
    UploadFixturesFixturesUploadPostError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
    },
    url: '/fixtures/upload',
  })
}

/**
 * List Dicom Tags
 */
export const listDicomTagsTagsDeidGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListDicomTagsTagsDeidGetResponse, ListDicomTagsTagsDeidGetError, ThrowOnError>(
    {
      ...options,
      url: '/tags-deid/',
    },
  )
}

/**
 * Create Dicom Tag
 */
export const createDicomTagTagsDeidPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateDicomTagTagsDeidPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateDicomTagTagsDeidPostResponse,
    CreateDicomTagTagsDeidPostError,
    ThrowOnError
  >({
    ...options,
    url: '/tags-deid/',
  })
}

/**
 * Get Dicom Tag
 */
export const getDicomTagTagsDeidDicomTagIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetDicomTagTagsDeidDicomTagIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetDicomTagTagsDeidDicomTagIdGetResponse,
    GetDicomTagTagsDeidDicomTagIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/tags-deid/{dicom_tag_id}',
  })
}

/**
 * Get Paginated Dicom Tags
 * Retrieves global dicom tags
 */
export const getPaginatedDicomTagsGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPaginatedDicomTagsStudiesDicomTagsGetResponse,
    GetDicomTagsStudiesDicomTagsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/tags-deid/paginated-dicom-tags',
  })
}

/**
 * Update Dicom Tag
 */
export const updateDicomTagTagsDeidDicomTagIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDicomTagTagsDeidDicomTagIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateDicomTagTagsDeidDicomTagIdPutResponse,
    UpdateDicomTagTagsDeidDicomTagIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/tags-deid/{dicom_tag_id}',
  })
}

/**
 * Delete Dicom Tag
 */
export const deleteDicomTagTagsDeidDicomTagIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDicomTagTagsDeidDicomTagIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteDicomTagTagsDeidDicomTagIdDeleteResponse,
    DeleteDicomTagTagsDeidDicomTagIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/tags-deid/{dicom_tag_id}',
  })
}

/**
 * Temporal Health
 * Check the health of the Temporal connection.
 */
export const temporalHealthWorkflowHealthGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    TemporalHealthWorkflowHealthGetResponse,
    TemporalHealthWorkflowHealthGetError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow/health',
  })
}

/**
 * Get Workflow Status
 * Get the status of a specific workflow.
 */
export const getWorkflowStatusWorkflowStatusWorkflowIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowStatusWorkflowStatusWorkflowIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowStatusWorkflowStatusWorkflowIdGetResponse,
    GetWorkflowStatusWorkflowStatusWorkflowIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow/status/{workflow_id}',
  })
}

/**
 * Start Qc Workflow
 * Start a new QC workflow.
 */
export const startQcWorkflowWorkflowStudyIdQcStartPost = <ThrowOnError extends boolean = false>(
  options: Options<StartQcWorkflowWorkflowStudyIdQcStartPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    StartQcWorkflowWorkflowStudyIdQcStartPostResponse,
    StartQcWorkflowWorkflowStudyIdQcStartPostError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow/{study_id}/qc/start',
  })
}

/**
 * Signal Qc Submission
 * Send a signal to a workflow indicating approval or rejection of a QC task.
 */
export const signalQcSubmissionWorkflowStudyIdQcWorkflowIdSignalSubmissionPost = <ThrowOnError extends boolean = false>(
  options: Options<SignalQcSubmissionWorkflowStudyIdQcWorkflowIdSignalSubmissionPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SignalQcSubmissionWorkflowStudyIdQcWorkflowIdSignalSubmissionPostResponse,
    SignalQcSubmissionWorkflowStudyIdQcWorkflowIdSignalSubmissionPostError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow/{study_id}/qc/{workflow_id}/signal/submission',
  })
}

/**
 * Study Timepoint Options Tus Files
 */
export const studyTimepointOptionsTusFilesTimepointFilesOptions = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).options<
    StudyTimepointOptionsTusFilesTimepointFilesOptionsResponse,
    StudyTimepointOptionsTusFilesTimepointFilesOptionsError,
    ThrowOnError
  >({
    ...options,
    url: '/timepoint/files',
  })
}

/**
 * Study Timepoint Create Tus Upload
 */
export const studyTimepointCreateTusUploadTimepointFilesPost = <ThrowOnError extends boolean = false>(
  options?: Options<StudyTimepointCreateTusUploadTimepointFilesPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    StudyTimepointCreateTusUploadTimepointFilesPostResponse,
    StudyTimepointCreateTusUploadTimepointFilesPostError,
    ThrowOnError
  >({
    ...options,
    url: '/timepoint/files',
  })
}

/**
 * Study Timepoint Upload Tus Chunk
 */
export const studyTimepointUploadTusChunkTimepointFilesUploadIdPatch = <ThrowOnError extends boolean = false>(
  options: Options<StudyTimepointUploadTusChunkTimepointFilesUploadIdPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    StudyTimepointUploadTusChunkTimepointFilesUploadIdPatchResponse,
    StudyTimepointUploadTusChunkTimepointFilesUploadIdPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/timepoint/files/{upload_id}',
  })
}

/**
 * Study Timepoint Status Tus Upload
 */
export const studyTimepointStatusTusUploadTimepointFilesUploadIdHead = <ThrowOnError extends boolean = false>(
  options: Options<StudyTimepointStatusTusUploadTimepointFilesUploadIdHeadData, ThrowOnError>,
) => {
  return (options?.client ?? client).head<
    StudyTimepointStatusTusUploadTimepointFilesUploadIdHeadResponse,
    StudyTimepointStatusTusUploadTimepointFilesUploadIdHeadError,
    ThrowOnError
  >({
    ...options,
    url: '/timepoint/files/{upload_id}',
  })
}

/**
 * Study Timepoint Delete Tus Upload
 */
export const studyTimepointDeleteTusUploadTimepointFilesUploadIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<StudyTimepointDeleteTusUploadTimepointFilesUploadIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    StudyTimepointDeleteTusUploadTimepointFilesUploadIdDeleteResponse,
    StudyTimepointDeleteTusUploadTimepointFilesUploadIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/timepoint/files/{upload_id}',
  })
}

/**
 * List Series Labels
 */
export const listSeriesLabelsSeriesLabelsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListSeriesLabelsSeriesLabelsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListSeriesLabelsSeriesLabelsGetResponse,
    ListSeriesLabelsSeriesLabelsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/series_labels/',
  })
}

/**
 * Create Series Label
 */
export const createSeriesLabelSeriesLabelsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateSeriesLabelSeriesLabelsPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateSeriesLabelSeriesLabelsPostResponse,
    CreateSeriesLabelSeriesLabelsPostError,
    ThrowOnError
  >({
    ...options,
    url: '/series_labels/',
  })
}

/**
 * Get Series Label Metadata
 */
export const getSeriesLabelMetadataSeriesLabelsMetadataGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSeriesLabelMetadataSeriesLabelsMetadataGetResponse,
    GetSeriesLabelMetadataSeriesLabelsMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/series_labels/metadata',
  })
}

/**
 * Get Series Label
 */
export const getSeriesLabelSeriesLabelsSeriesLabelIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetSeriesLabelSeriesLabelsSeriesLabelIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSeriesLabelSeriesLabelsSeriesLabelIdGetResponse,
    GetSeriesLabelSeriesLabelsSeriesLabelIdGetError,
    ThrowOnError
  >({
    ...options,
    url: '/series_labels/{series_label_id}',
  })
}

/**
 * Update Series Label
 */
export const updateSeriesLabelSeriesLabelsSeriesLabelIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSeriesLabelSeriesLabelsSeriesLabelIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateSeriesLabelSeriesLabelsSeriesLabelIdPutResponse,
    UpdateSeriesLabelSeriesLabelsSeriesLabelIdPutError,
    ThrowOnError
  >({
    ...options,
    url: '/series_labels/{series_label_id}',
  })
}

/**
 * Delete Series Label
 */
export const deleteSeriesLabelSeriesLabelsSeriesLabelIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSeriesLabelSeriesLabelsSeriesLabelIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteSeriesLabelSeriesLabelsSeriesLabelIdDeleteResponse,
    DeleteSeriesLabelSeriesLabelsSeriesLabelIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/series_labels/{series_label_id}',
  })
}

/**
 * Batch Delete Series Labels
 */
export const batchDeleteSeriesLabelsSeriesLabelsBatchDeletePost = <ThrowOnError extends boolean = false>(
  options: Options<BatchDeleteSeriesLabelsSeriesLabelsBatchDeletePostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchDeleteSeriesLabelsSeriesLabelsBatchDeletePostResponse,
    BatchDeleteSeriesLabelsSeriesLabelsBatchDeletePostError,
    ThrowOnError
  >({
    ...options,
    url: '/series_labels/batch-delete',
  })
}

/**
 * List Users
 */
export const listUsersUsersGet = <ThrowOnError extends boolean = false>(
  options: Options<ListUsersUsersGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListUsersUsersGetResponse, ListUsersUsersGetError, ThrowOnError>({
    ...options,
    url: '/users/',
  })
}

/**
 * Add User
 */
export const addUserUsersPost = <ThrowOnError extends boolean = false>(
  options: Options<AddUserUsersPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<AddUserUsersPostResponse, AddUserUsersPostError, ThrowOnError>({
    ...options,
    url: '/users/',
  })
}

/**
 * Get User
 */
export const getUserUsersUserIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetUserUsersUserIdGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetUserUsersUserIdGetResponse, GetUserUsersUserIdGetError, ThrowOnError>({
    ...options,
    url: '/users/{user_id}',
  })
}

/**
 * Update User
 */
export const updateUserUsersUserIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserUsersUserIdPutData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<UpdateUserUsersUserIdPutResponse, UpdateUserUsersUserIdPutError, ThrowOnError>(
    {
      ...options,
      url: '/users/{user_id}',
    },
  )
}

/**
 * Remove User
 */
export const removeUserUsersUserIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<RemoveUserUsersUserIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    RemoveUserUsersUserIdDeleteResponse,
    RemoveUserUsersUserIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/users/{user_id}',
  })
}

/**
 * List User Study Assignments
 */
export const listUserStudyAssignmentsUsersUserIdStudyAssignmentsGet = <ThrowOnError extends boolean = false>(
  options: Options<ListUserStudyAssignmentsUsersUserIdStudyAssignmentsGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListUserStudyAssignmentsUsersUserIdStudyAssignmentsGetResponse,
    ListUserStudyAssignmentsUsersUserIdStudyAssignmentsGetError,
    ThrowOnError
  >({
    ...options,
    url: '/users/{user_id}/study_assignments',
  })
}

/**
 * Delete User Study Assignment
 */
export const deleteUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdDeleteResponse,
    DeleteUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/users/{user_id}/study_assignments/{study_user_role_id}',
  })
}

/**
 * Update User Study Assignment
 */
export const updateUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdPatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdPatchResponse,
    UpdateUserStudyAssignmentUsersUserIdStudyAssignmentsStudyUserRoleIdPatchError,
    ThrowOnError
  >({
    ...options,
    url: '/users/{user_id}/study_assignments/{study_user_role_id}',
  })
}

/**
 * Get Study Assignments Metadata
 */
export const getStudyAssignmentsMetadataUsersStudyAssignmentsMetadataGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetStudyAssignmentsMetadataUsersStudyAssignmentsMetadataGetResponse,
    GetStudyAssignmentsMetadataUsersStudyAssignmentsMetadataGetError,
    ThrowOnError
  >({
    ...options,
    url: '/users/study_assignments/metadata',
  })
}

/**
 * Create User Study Assignments
 */
export const createUserStudyAssignmentsUsersUserIdStudyAssignmentsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateUserStudyAssignmentsUsersUserIdStudyAssignmentsPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateUserStudyAssignmentsUsersUserIdStudyAssignmentsPostResponse,
    CreateUserStudyAssignmentsUsersUserIdStudyAssignmentsPostError,
    ThrowOnError
  >({
    ...options,
    url: '/users/{user_id}/study_assignments/',
  })
}

/**
 * Download User Audit Report
 */
export const downloadUserAuditReportUsersAuditReportDownloadPost = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DownloadUserAuditReportUsersAuditReportDownloadPostResponse,
    DownloadUserAuditReportUsersAuditReportDownloadPostError,
    ThrowOnError
  >({
    ...options,
    url: '/users/audit-report/download',
  })
}

/**
 * Health Check
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<HealthCheckHealthGetResponse, HealthCheckHealthGetError, ThrowOnError>({
    ...options,
    url: '/health',
  })
}

/**
 * Trigger Error
 */
export const triggerErrorSentryDebugGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    TriggerErrorSentryDebugGetResponse,
    TriggerErrorSentryDebugGetError,
    ThrowOnError
  >({
    ...options,
    url: '/sentry-debug',
  })
}

/**
 * Ping Db
 */
export const pingDbPingDbGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
  return (options?.client ?? client).get<PingDbPingDbGetResponse, PingDbPingDbGetError, ThrowOnError>({
    ...options,
    url: '/ping-db',
  })
}
